
(function __ppBoot(){
if(!window.React||!window.ReactDOM||!window.ReactDOM.createRoot){return setTimeout(__ppBoot,20);}

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return React.createElement(React.Fragment, null, React.createElement("style", null, __TWEAKS_STYLE), React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, React.createElement("b", null, title), React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), React.createElement("div", {
    className: "twk-body"
  }, children)));
}
function TweakSection({
  label,
  children
}) {
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, React.createElement("div", {
    className: "twk-lbl"
  }, React.createElement("span", null, label), value != null && React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}
function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return React.createElement("div", {
    className: "twk-row twk-row-h"
  }, React.createElement("div", {
    className: "twk-lbl"
  }, React.createElement("span", null, label)), React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  const valueRef = React.useRef(value);
  valueRef.current = value;
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return React.createElement(TweakRow, {
    label: label
  }, React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return React.createElement(TweakRow, {
    label: label
  }, React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return React.createElement(TweakRow, {
    label: label
  }, React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return React.createElement("div", {
    className: "twk-num"
  }, React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return React.createElement("div", {
      className: "twk-row twk-row-h"
    }, React.createElement("div", {
      className: "twk-lbl"
    }, React.createElement("span", null, label)), React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return React.createElement(TweakRow, {
    label: label
  }, React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && React.createElement("span", null, sup.map((c, j) => React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState,
  useEffect,
  useRef
} = React;
const Icon = {
  Check: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  })),
  X: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), React.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })),
  Arrow: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }), React.createElement("polyline", {
    points: "12 5 19 12 12 19"
  })),
  Plus: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.5",
    strokeLinecap: "round"
  }, p), React.createElement("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), React.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })),
  Shield: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
  }), React.createElement("polyline", {
    points: "9 12 11 14 15 10"
  })),
  Leaf: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"
  }), React.createElement("path", {
    d: "M2 21c0-3 1.85-5.36 5.08-6"
  })),
  Spoon: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("circle", {
    cx: "12",
    cy: "6",
    r: "4"
  }), React.createElement("path", {
    d: "M12 10c0 2 2 4 2 8c0 2-1 4-2 4s-2-2-2-4c0-4 2-6 2-8z"
  })),
  Moon: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
  })),
  Bolt: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("polygon", {
    points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
  })),
  Heart: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
  })),
  Droplet: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
  })),
  Bowl: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M2 12h20"
  }), React.createElement("path", {
    d: "M3 12a9 9 0 0 0 18 0"
  }), React.createElement("path", {
    d: "M12 8c-1.5-2 1.5-3 0-5"
  })),
  Truck: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("rect", {
    x: "1",
    y: "6",
    width: "14",
    height: "11",
    rx: "1"
  }), React.createElement("path", {
    d: "M15 9h4l3 3v5h-7z"
  }), React.createElement("circle", {
    cx: "6",
    cy: "20",
    r: "2"
  }), React.createElement("circle", {
    cx: "18",
    cy: "20",
    r: "2"
  })),
  Cash: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("rect", {
    x: "2",
    y: "6",
    width: "20",
    height: "12",
    rx: "2"
  }), React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })),
  Lock: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2"
  }), React.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  })),
  Verified: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, p), React.createElement("path", {
    d: "M12 2l2.4 1.8 3 0L18 6.6l2.5 1.4-1 2.8 1 2.8L18 15l-.6 2.8-3 0L12 19.6 9.6 17.8l-3 0L6 15l-2.5-1.4 1-2.8-1-2.8L6 6.6l.6-2.8 3 0z"
  }), React.createElement("polyline", {
    points: "9 12 11 14 15 10",
    stroke: "white",
    strokeWidth: "2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })),
  Doc: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  })),
  Box: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
  }), React.createElement("polyline", {
    points: "3.27 6.96 12 12.01 20.73 6.96"
  }), React.createElement("line", {
    x1: "12",
    y1: "22.08",
    x2: "12",
    y2: "12"
  })),
  Star: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, p), React.createElement("polygon", {
    points: "12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
  })),
  StarBadge: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, p), React.createElement("path", {
    d: "M12 1L9.4 6.4L3.5 7.3L7.8 11.4L6.8 17.2L12 14.5L17.2 17.2L16.2 11.4L20.5 7.3L14.6 6.4z"
  })),
  Gift: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("polyline", {
    points: "20 12 20 22 4 22 4 12"
  }), React.createElement("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "5"
  }), React.createElement("line", {
    x1: "12",
    y1: "22",
    x2: "12",
    y2: "7"
  }), React.createElement("path", {
    d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
  }), React.createElement("path", {
    d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
  })),
  ZZ: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M6 7h6l-6 8h6"
  }), React.createElement("path", {
    d: "M14 4h4l-4 5h4"
  })),
  Sparkle: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, p), React.createElement("path", {
    d: "M12 2l1.5 6.5L20 10l-6.5 1.5L12 18l-1.5-6.5L4 10l6.5-1.5z"
  })),
  Cycle: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("polyline", {
    points: "23 4 23 10 17 10"
  }), React.createElement("polyline", {
    points: "1 20 1 14 7 14"
  }), React.createElement("path", {
    d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
  })),
  Crown: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, p), React.createElement("path", {
    d: "M3 19h18l-1.5-9-4 3L12 5l-3.5 8-4-3z"
  })),
  Stethoscope: p => React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), React.createElement("path", {
    d: "M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"
  }), React.createElement("path", {
    d: "M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4"
  }), React.createElement("circle", {
    cx: "20",
    cy: "10",
    r: "2"
  }))
};
window.Icon = Icon;

/* hooks ya declarados arriba */
const Eyebrow = ({
  tone = 'ink',
  children
}) => React.createElement("span", {
  className: `eyebrow ${tone === 'mint' ? 'mint' : tone === 'pink' ? 'pink' : tone === 'cream' ? 'cream' : ''}`
}, children);
function triggerRSI(qty) {
  var a = document.getElementById('_rsi-buy-now-button-overwrite');
  if (!a) return;
  var q = qty || 1;
  var pp = window.__PP_PRODUCT || {};
  if (pp.variantId) {
    window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [{
      id: pp.variantId,
      quantity: q
    }];
  }
  var qInput = document.getElementById('_rsi-qty-input');
  if (!qInput) {
    qInput = document.createElement('input');
    qInput.type = 'hidden';
    qInput.name = 'quantity';
    qInput.id = '_rsi-qty-input';
    document.body.appendChild(qInput);
  }
  qInput.value = String(q);
  a.style.removeProperty('display');
  a.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;';
  a.click();
  setTimeout(function () {
    a.style.setProperty('display', 'none', 'important');
  }, 300);
}
const PrimaryCTA = ({
  children = (window.__PP_SETTINGS || {}).cta_text || 'La quiero probar',
  onClick,
  qty
}) => React.createElement("button", {
  className: "cta",
  onClick: e => {
    triggerRSI(qty);
    if (onClick) onClick(e);
  }
}, React.createElement("span", null, children), React.createElement(Icon.Arrow, {
  className: "ar"
}));
const CTARow = () => React.createElement("div", {
  className: "cta-row"
}, "Env\xEDo gratis ", React.createElement("span", {
  className: "sep"
}, "\xB7"), " Pagas al recibir ", React.createElement("span", {
  className: "sep"
}, "\xB7"), " Garant\xEDa 30 d\xEDas");
const CountdownBar = () => {
  const DURATION = 12 * 60 * 60 * 1000;
  const KEY = 'pp_offer_deadline';
  const getDeadline = () => {
    var now = Date.now();
    var saved = null;
    try {
      saved = parseInt(localStorage.getItem(KEY), 10);
    } catch (e) {}
    if (!saved || isNaN(saved) || saved <= now) {
      saved = now + DURATION;
      try {
        localStorage.setItem(KEY, String(saved));
      } catch (e) {}
    }
    return saved;
  };
  const calc = deadline => {
    var diff = Math.max(0, deadline - Date.now());
    var h = Math.floor(diff / 3600000);
    var m = Math.floor(diff % 3600000 / 60000);
    var s = Math.floor(diff % 60000 / 1000);
    return {
      h: h,
      m: m,
      s: s
    };
  };
  const deadlineRef = useRef(getDeadline());
  const [t, setT] = useState(calc(deadlineRef.current));
  useEffect(() => {
    var id = setInterval(function () {
      if (Date.now() >= deadlineRef.current) {
        deadlineRef.current = Date.now() + DURATION;
        try {
          localStorage.setItem(KEY, String(deadlineRef.current));
        } catch (e) {}
      }
      setT(calc(deadlineRef.current));
    }, 1000);
    return function () {
      clearInterval(id);
    };
  }, []);
  const pad = n => n < 10 ? '0' + n : '' + n;
  return React.createElement("div", {
    className: "pp-countdown",
    "aria-label": "Oferta por tiempo limitado"
  }, React.createElement("span", {
    className: "pp-countdown__label"
  }, React.createElement("span", {
    className: "pp-countdown__fire"
  }, "\uD83D\uDD25"), " Oferta que termina hoy"), React.createElement("span", {
    className: "pp-countdown__timer"
  }, React.createElement("span", {
    className: "pp-countdown__unit"
  }, React.createElement("span", {
    className: "pp-countdown__num"
  }, pad(t.h)), React.createElement("span", {
    className: "pp-countdown__cap"
  }, "Hrs")), React.createElement("span", {
    className: "pp-countdown__sep"
  }, ":"), React.createElement("span", {
    className: "pp-countdown__unit"
  }, React.createElement("span", {
    className: "pp-countdown__num"
  }, pad(t.m)), React.createElement("span", {
    className: "pp-countdown__cap"
  }, "Min")), React.createElement("span", {
    className: "pp-countdown__sep"
  }, ":"), React.createElement("span", {
    className: "pp-countdown__unit"
  }, React.createElement("span", {
    className: "pp-countdown__num"
  }, pad(t.s)), React.createElement("span", {
    className: "pp-countdown__cap"
  }, "Seg"))));
};
const PromoBar = () => {
  var cfgItems = window.__PP_PROMO && window.__PP_PROMO.items || [];
  const items = cfgItems && cfgItems.length ? cfgItems : ['Envío gratis a toda Colombia', 'Garantía 30 días · 100% reembolso', 'Pago contra entrega', '+8.000 clientes', '★ 4.8 de calificación', 'Sin azúcar añadida', '100% natural · sin químicos'];
  const track = [...items, ...items];
  return React.createElement("div", {
    className: "promo promo--marquee",
    "aria-label": "Beneficios y garant\xEDas"
  }, React.createElement("div", {
    className: "promo__track"
  }, track.map((t, i) => React.createElement("span", {
    className: "promo__item",
    key: i
  }, React.createElement("span", null, t), React.createElement("span", {
    className: "dot"
  })))));
};
const Nav = () => {
  var brand = window.__PP_PROMO && window.__PP_PROMO.brand || 'JoySpring';
  return React.createElement("div", {
    className: "nav"
  }, React.createElement("div", {
    className: "brand"
  }, React.createElement("div", {
    className: "brand-dot"
  }, React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "16",
    height: "16",
    fill: "none",
    stroke: "#2a2d62",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
  }))), React.createElement("span", null, brand), React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontWeight: 600,
      marginLeft: 2,
      fontSize: 13
    }
  }, "\xB7 Colombia")), React.createElement("svg", {
    className: "menu",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round"
  }, React.createElement("line", {
    x1: "4",
    y1: "8",
    x2: "20",
    y2: "8"
  }), React.createElement("line", {
    x1: "4",
    y1: "16",
    x2: "20",
    y2: "16"
  })));
};
const Hero = ({
  heroVariant = 'human'
}) => {
  return React.createElement("section", {
    className: "hero",
    "data-screen-label": "01 Hero"
  }, React.createElement("div", {
    className: "mom-pill"
  }, React.createElement("div", {
    className: "avs"
  }, React.createElement("div", {
    className: "av",
    style: {
      backgroundImage: 'url(' + window.__resources.mom1 + ')'
    }
  }), React.createElement("div", {
    className: "av",
    style: {
      backgroundImage: 'url(' + window.__resources.mom2 + ')'
    }
  }), React.createElement("div", {
    className: "av",
    style: {
      backgroundImage: 'url(' + window.__resources.mom3 + ')'
    }
  })), React.createElement("span", null, "+8.000 colombianos"), React.createElement("span", {
    style: {
      color: 'var(--pink)',
      marginLeft: 2
    }
  }, "\u2605 4.8")), React.createElement("h1", null, "La creatina que ", React.createElement("span", {
    className: "accent"
  }, "comer, dormir y crecer.")), React.createElement("p", {
    className: "sub"
  }, "Creatina monohidratada en gomitas, la más estudiada para fuerza y rendimiento — en un formato que sí te tomas \u2014 sin shaker ni grumos."), React.createElement("div", {
    className: "visual"
  }, React.createElement("img", {
    src: window.__resources.heroMomKid,
    alt: "Mam\xE1 con su hijo y Beast Bites"
  }), React.createElement("div", {
    className: "visual-overlay"
  }, React.createElement("span", {
    className: "v-chip"
  }, React.createElement(Icon.Leaf, {
    className: "ico"
  }), " creatina monohidratada"), React.createElement("span", {
    className: "v-chip"
  }, React.createElement(Icon.Check, {
    className: "ico"
  }), " Sin shaker \xB7 sin grumos"))), React.createElement("div", {
    className: "trust-row"
  }, React.createElement("div", {
    className: "trust-cell"
  }, React.createElement(Icon.Leaf, {
    className: "ti mint"
  }), " 100% Natural"), React.createElement("div", {
    className: "trust-cell"
  }, React.createElement(Icon.Shield, {
    className: "ti"
  }), " Sin azúcar"), React.createElement("div", {
    className: "trust-cell"
  }, React.createElement(Icon.Heart, {
    className: "ti"
  }), " 90 gomitas"), React.createElement("div", {
    className: "trust-cell"
  }, React.createElement(Icon.Droplet, {
    className: "ti mint"
  }), " Sin grumos")), React.createElement(PrimaryCTA, null), React.createElement(CTARow, null));
};
const Symptoms = () => {
  var c = window.__PP_SYMPTOMS || {};
  var defSymptoms = ['No quiere comer', 'Solo quiere dulces', 'Le pica la colita', 'Le rechina los dientes', 'No duerme bien'];
  var raw = [c.symptom_1, c.symptom_2, c.symptom_3, c.symptom_4, c.symptom_5];
  const items = raw.map((s, i) => {
    var txt = s && s.length ? s : defSymptoms[i];
    var parts = txt.split(' ');
    var strong = parts.slice(0, 2).join(' ');
    var rest = parts.length > 2 ? ' ' + parts.slice(2).join(' ') : '';
    return {
      strong: strong,
      rest: rest
    };
  });
  return React.createElement("section", {
    className: "section bg-mint",
    "data-screen-label": "02 S\xEDntomas"
  }, React.createElement(Eyebrow, {
    tone: "mint"
  }, c.eyebrow || '¿Te suena familiar?'), React.createElement("h2", {
    className: "h-section"
  }, c.title || 'Si tu hijo tiene 3 de estas señales, no está siendo "mañoso".'), React.createElement("div", {
    className: "symptoms-list"
  }, items.map((it, i) => React.createElement("div", {
    className: "symptom",
    key: i
  }, React.createElement("span", {
    className: "chk"
  }, React.createElement(Icon.Check, null)), React.createElement("span", null, React.createElement("strong", null, it.strong), it.rest)))), React.createElement("div", {
    className: "diag-card"
  }, React.createElement("div", {
    className: "label"
  }, c.diag_label || 'Podrían ser'), React.createElement("div", {
    className: "name"
  }, React.createElement("span", {
    className: "hl"
  }, c.diag_name || 'Parásitos intestinales')), React.createElement("p", {
    className: "sub"
  }, c.diag_sub || 'El 80% de los niños entre 4 y 8 años los tiene — y la mayoría no lo sabe.')));
};
const Benefits = ({
  variant = 'grid'
}) => {
  var c = window.__PP_BENEFITS || {};
  const benefits = [{
    name: 'Más fuerza',
    desc: 'Más potencia en cada serie del gym.',
    icon: React.createElement(Icon.Bolt, null)
  }, {
    name: 'Más músculo',
    desc: 'Apoya el crecimiento muscular con tu entreno.',
    icon: React.createElement(Icon.Bowl, null),
    pink: true
  }, {
    name: 'Mejor recuperación',
    desc: 'Te recuperas mejor entre entrenos.',
    icon: React.createElement(Icon.Cycle, null)
  }, {
    name: 'Más energía',
    desc: 'Más aguante y energía durante el día.',
    icon: React.createElement(Icon.Bolt, null),
    pink: true
  }, {
    name: 'Más energía',
    desc: 'Más aguante y energía en cada entreno.',
    icon: React.createElement(Icon.Shield, null)
  }];
  return React.createElement("section", {
    className: "section bg-white",
    "data-screen-label": "03 Beneficios"
  }, React.createElement(Eyebrow, {
    tone: "pink"
  }, c.eyebrow || 'Lo que cambia'), React.createElement("h2", {
    className: "h-section"
  }, c.title || '5 cambios que verás en menos de 2 semanas.'), React.createElement("div", {
    className: "benefits-grid"
  }, benefits.slice(0, 4).map((b, i) => React.createElement("div", {
    className: `benefit ${b.pink ? 'is-pink' : ''}`,
    key: i
  }, React.createElement("div", {
    className: "icon"
  }, b.icon), React.createElement("div", {
    className: "name"
  }, b.name), React.createElement("div", {
    className: "desc"
  }, b.desc))), React.createElement("div", {
    className: "benefit wide"
  }, React.createElement("div", {
    className: "icon"
  }, React.createElement(Icon.Shield, null)), React.createElement("div", {
    className: "text"
  }, React.createElement("div", {
    className: "name"
  }, "Refuerza sus defensas"), React.createElement("div", {
    className: "desc"
  }, "Gomitas que protegen el músculo por 6 meses \u2014 no es un parche, es prevenci\xF3n real.")))), React.createElement("div", {
    className: "ba-card"
  }, React.createElement("div", {
    className: "ba-img"
  }, React.createElement("img", {
    src: window.__resources.beforeAfter,
    alt: "Antes y despu\xE9s con Beast Bites"
  }), React.createElement("span", {
    className: "ba-tag ba-tag--left"
  }, "D\xEDa 1"), React.createElement("span", {
    className: "ba-tag ba-tag--right"
  }, "D\xEDa 30")), React.createElement("div", {
    className: "ba-caption"
  }, React.createElement("span", {
    className: "ba-cap-l"
  }, "Antes: sin fuerza"), React.createElement("span", {
    className: "ba-arrow"
  }, "\u2192"), React.createElement("span", {
    className: "ba-cap-r"
  }, "Ahora: rinde más"))), React.createElement("div", {
    className: "ba-cta-wrap"
  }, React.createElement("span", {
    className: "ba-cta-step"
  }, "TU PR\xD3XIMO PASO"), React.createElement("h3", {
    className: "ba-cta-title"
  }, "Hoy puedes empezar", React.createElement("br", null), "a verlo cambiar."), React.createElement("div", {
    className: "ba-cta-micro"
  }, React.createElement("span", {
    className: "avs"
  }, React.createElement("span", {
    className: "av",
    style: {
      backgroundImage: 'url(' + window.__resources.mom1 + ')'
    }
  }), React.createElement("span", {
    className: "av",
    style: {
      backgroundImage: 'url(' + window.__resources.mom2 + ')'
    }
  }), React.createElement("span", {
    className: "av",
    style: {
      backgroundImage: 'url(' + window.__resources.mom3 + ')'
    }
  })), React.createElement("span", null, "+8.000 mam\xE1s colombianas ya lo hicieron")), React.createElement(PrimaryCTA, null, "La quiero probar"), React.createElement("div", {
    className: "ba-cta-row"
  }, React.createElement(Icon.Shield, {
    style: {
      width: 12,
      height: 12,
      color: 'var(--mint-600)'
    }
  }), " Garant\xEDa 30 d\xEDas \xB7 Pagas al recibir")));
};
const Phases = () => {
  var c = window.__PP_PHASES || {};
  const phases = [{
    label: c.f1_label || 'Fase 1 · Arrastre',
    title: c.f1_title || 'Limpia suave por dentro',
    days: c.f1_days || 'Día 1 al 7',
    img: window.__resources.mascotFase1,
    desc: c.f1_desc || 'Empieza la limpieza suave en tu músculo. Vuelve el hambre real y duerme más tranquilo.',
    herbs: ['Nogal negro', 'Ajenjo', 'Tomillo'],
    cls: 'f1',
    num: '1'
  }, {
    label: c.f2_label || 'Fase 2 · Reparación',
    title: c.f2_title || 'Repara tu músculo',
    days: c.f2_days || 'Día 8 al 20',
    img: window.__resources.mascotFase2,
    desc: c.f2_desc || 'Tus músculos se recuperan mejor y aguantas más series en cada entreno.',
    herbs: ['Calabaza', 'Orégano', 'Cardamomo'],
    cls: 'f2',
    num: '2'
  }, {
    label: c.f3_label || 'Fase 3 · Protección',
    title: c.f3_title || 'La mantienes fácil',
    days: c.f3_days || 'Día 21 al 30',
    img: window.__resources.mascotFase3,
    desc: c.f3_desc || 'Recupera energía, duerme mejor y ayuda a proteger tu músculo por más tiempo.',
    herbs: ['Clavo de olor', 'Canela', 'Jengibre'],
    cls: 'f3',
    num: '3'
  }];
  const [active, setActive] = React.useState(() => new Set());
  const refs = React.useRef([]);
  React.useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') {
      setActive(new Set([0, 1, 2]));
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const idx = Number(e.target.getAttribute('data-idx'));
          setActive(prev => {
            if (prev.has(idx)) return prev;
            const next = new Set(prev);
            next.add(idx);
            return next;
          });
          io.unobserve(e.target);
        }
      });
    }, {
      threshold: 0.35,
      rootMargin: '0px 0px -10% 0px'
    });
    refs.current.forEach(el => el && io.observe(el));
    return () => io.disconnect();
  }, []);
  return React.createElement("section", {
    className: "section bg-cream",
    "data-screen-label": "04 Sistema 3 Fases"
  }, React.createElement(Eyebrow, {
    tone: "ink"
  }, c.eyebrow || 'Cómo funciona'), React.createElement("h2", {
    className: "h-section"
  }, c.title || 'Así recuperas a tu hijo, semana a semana.'), React.createElement("div", {
    className: "phases-stack phases-stack--clean"
  }, phases.map((p, i) => React.createElement(React.Fragment, {
    key: i
  }, i > 0 && React.createElement("div", {
    className: 'ph-connector' + (active.has(i) ? ' is-drawn' : ''),
    "aria-hidden": "true"
  }, React.createElement("span", {
    className: "ph-connector__line"
  })), React.createElement("div", {
    ref: el => refs.current[i] = el,
    "data-idx": i,
    className: 'ph-card ' + p.cls + ' is-lit' + (i === phases.length - 1 ? ' is-last' : '') + (active.has(i) ? ' is-active' : '')
  }, React.createElement("div", {
    className: "ph-head"
  }, React.createElement("span", {
    className: 'ph-node ' + p.cls
  }, p.num), React.createElement("div", null, React.createElement("div", {
    className: 'ph-lbl ' + p.cls
  }, p.label), React.createElement("div", {
    className: "ph-days"
  }, p.days))), React.createElement("div", {
    className: "ph-img"
  }, React.createElement("img", {
    src: p.img,
    alt: p.title
  })), React.createElement("h3", {
    className: "ph-title"
  }, p.title), React.createElement("p", {
    className: "ph-desc"
  }, p.desc), React.createElement("div", {
    className: "ph-herbs"
  }, p.herbs.map(h => React.createElement("span", {
    className: "ph-herb",
    key: h
  }, h))))))));
};
const Usage = () => {
  return React.createElement("section", {
    className: "section bg-mint",
    "data-screen-label": "05 F\xE1cil de usar"
  }, React.createElement(Eyebrow, {
    tone: "mint"
  }, "F\xE1cil de usar"), React.createElement("h2", {
    className: "h-section"
  }, "3 gomitas al d\xEDa. ", React.createElement("br", null), "2 formas f\xE1ciles."), React.createElement("p", {
    className: "kicker"
  }, "Para mam\xE1s que no quieren pelea con la comida."), React.createElement("div", {
    className: "usage-grid"
  }, React.createElement("div", {
    className: "usage"
  }, React.createElement("div", {
    className: "visual",
    style: {
      background: 'linear-gradient(135deg, #fbeaee 0%, #fde8d6 100%)'
    }
  }, React.createElement("svg", {
    viewBox: "0 0 120 120",
    style: {
      width: '70%',
      height: '70%'
    }
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: "bot1",
    x1: "0",
    x2: "0",
    y1: "0",
    y2: "1"
  }, React.createElement("stop", {
    offset: "0",
    stopColor: "#5dbfa1"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4a9d83"
  }))), React.createElement("rect", {
    x: "48",
    y: "15",
    width: "24",
    height: "14",
    rx: "3",
    fill: "#2a2d62"
  }), React.createElement("rect", {
    x: "44",
    y: "29",
    width: "32",
    height: "48",
    rx: "6",
    fill: "url(#bot1)"
  }), React.createElement("rect", {
    x: "50",
    y: "40",
    width: "20",
    height: "22",
    rx: "3",
    fill: "#fff",
    opacity: "0.4"
  }), React.createElement("circle", {
    cx: "60",
    cy: "92",
    r: "3",
    fill: "#1e88e5"
  }), React.createElement("circle", {
    cx: "60",
    cy: "105",
    r: "2",
    fill: "#1e88e5",
    opacity: "0.6"
  }), React.createElement("path", {
    d: "M 35 100 Q 60 115 85 100 Q 75 112 60 112 Q 45 112 35 100Z",
    fill: "#e8a578",
    opacity: "0.5"
  }))), React.createElement("div", {
    className: "step"
  }, "1"), React.createElement("div", {
    className: "way"
  }, "Forma 1"), React.createElement("h4", null, "Directo en la boca"), React.createElement("div", {
    className: "d"
  }, "Te las comes como un dulce. Sin agua.")), React.createElement("div", {
    className: "usage"
  }, React.createElement("div", {
    className: "visual",
    style: {
      background: 'linear-gradient(135deg, #fff3c4 0%, #ffd9a0 100%)'
    }
  }, React.createElement("svg", {
    viewBox: "0 0 120 120",
    style: {
      width: '85%',
      height: '85%'
    }
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: "bot2",
    x1: "0",
    x2: "0",
    y1: "0",
    y2: "1"
  }, React.createElement("stop", {
    offset: "0",
    stopColor: "#5dbfa1"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4a9d83"
  })), React.createElement("linearGradient", {
    id: "juice",
    x1: "0",
    x2: "0",
    y1: "0",
    y2: "1"
  }, React.createElement("stop", {
    offset: "0",
    stopColor: "#ffb547"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#f08a2c"
  }))), React.createElement("path", {
    d: "M 32 60 L 88 60 L 82 110 L 38 110 Z",
    fill: "#fff",
    opacity: "0.75",
    stroke: "#fff"
  }), React.createElement("path", {
    d: "M 35 65 L 85 65 L 81 108 L 39 108 Z",
    fill: "url(#juice)"
  }), React.createElement("rect", {
    x: "70",
    y: "18",
    width: "14",
    height: "8",
    rx: "2",
    fill: "#2a2d62"
  }), React.createElement("rect", {
    x: "68",
    y: "26",
    width: "18",
    height: "28",
    rx: "4",
    fill: "url(#bot2)"
  }), React.createElement("ellipse", {
    cx: "65",
    cy: "58",
    rx: "3",
    ry: "4",
    fill: "#f08a2c"
  }))), React.createElement("div", {
    className: "step"
  }, "2"), React.createElement("div", {
    className: "way"
  }, "Forma 2"), React.createElement("h4", null, "En su bebida favorita"), React.createElement("div", {
    className: "d"
  }, "Mezclado en jugo, agua o leche. Ni lo nota."))), React.createElement("div", {
    style: {
      marginTop: 'var(--s5)',
      padding: '14px 16px',
      background: 'var(--mint-50)',
      borderRadius: 'var(--r-md)',
      border: '1px solid var(--mint-100)',
      display: 'flex',
      gap: 10,
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      width: 32,
      height: 32,
      borderRadius: 999,
      background: 'var(--mint)',
      display: 'grid',
      placeItems: 'center',
      flexShrink: 0,
      color: 'var(--ink)'
    }
  }, React.createElement(Icon.Sparkle, {
    style: {
      width: 14,
      height: 14
    }
  })), React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 600,
      color: 'var(--ink)',
      lineHeight: 1.4
    }
  }, React.createElement("strong", {
    style: {
      color: 'var(--ink)'
    }
  }, "Sin pelea, sin drama."), " Agita antes de usar. Ma\xF1ana es ideal.")));
};
window.Sec1 = {
  PromoBar,
  CountdownBar,
  Nav,
  Hero,
  Symptoms,
  Benefits,
  Phases,
  Usage,
  Eyebrow,
  PrimaryCTA,
  CTARow
};

const {
  useState: useState2
} = React;
const NaturalVsChem = () => {
  return React.createElement("section", {
    className: "section bg-cream2",
    "data-screen-label": "06 Natural vs Qu\xEDmico"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "ink"
  }, "Por qu\xE9 las mam\xE1s eligen natural"), React.createElement("h2", {
    className: "h-section"
  }, "No es lo mismo limpiar que medicar."), React.createElement("div", {
    className: "nvsq"
  }, React.createElement("div", {
    className: "nvsq-card natural"
  }, React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, React.createElement("span", {
    className: "ribbon"
  }, React.createElement(Icon.Leaf, {
    style: {
      width: 11,
      height: 11
    }
  }), " Lo que recomendamos")), React.createElement("h3", null, "Sistema natural en gotas"), React.createElement("div", {
    className: "pts"
  }, React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.Check, {
    className: "ic"
  }), React.createElement("span", null, "Creatina monohidratada real", React.createElement("strong", null, ""), "")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.Check, {
    className: "ic"
  }), React.createElement("span", null, "90 gomitas \xB7 30 d\xEDas de uso")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.Check, {
    className: "ic"
  }), React.createElement("span", null, "Más fuerza y m\xE1s repeticiones")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.Check, {
    className: "ic"
  }), React.createElement("span", null, "Sabor frambuesa \xB7 sin grumos")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.Check, {
    className: "ic"
  }), React.createElement("span", null, "Constancia sin esfuerzo"))), React.createElement("div", {
    className: "price"
  }, React.createElement("span", {
    className: "lab"
  }, "Costo total"), React.createElement("span", {
    className: "val"
  }, "$99.900"), React.createElement("span", {
    style: {
      fontSize: 11,
      color: 'var(--muted-2)',
      textDecoration: 'line-through',
      marginLeft: 'auto'
    }
  }, "$140.000"))), React.createElement("div", {
    className: "nvsq-card chem"
  }, React.createElement("span", {
    className: "ribbon"
  }, React.createElement(Icon.X, {
    style: {
      width: 11,
      height: 11
    }
  }), " Creatina en polvo"), React.createElement("h3", null, "Creatina en polvo"), React.createElement("div", {
    className: "pts"
  }, React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "Toca cargar shaker a todos lados")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "1 sola dosis \xB7 efecto corto")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "Se te olvida \xB7 la dejas a la semana")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "Sabor a arena \xB7 da pereza tomarlo")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "Vuelven cada 3 meses"))), React.createElement("div", {
    className: "price"
  }, React.createElement("span", {
    className: "lab"
  }, "F\xE1cil de dejarla"), React.createElement("span", {
    className: "val"
  }, "A medio usar")))), React.createElement("p", {
    style: {
      marginTop: 'var(--s5)',
      textAlign: 'center',
      fontSize: 12.5,
      color: 'var(--muted)',
      fontWeight: 500,
      fontStyle: 'italic',
      lineHeight: 1.5
    }
  }, "4 pastillas al a\xF1o, sin resolver de fondo. Una mam\xE1 nos lo dijo: ", React.createElement("strong", {
    style: {
      color: 'var(--ink-2)'
    }
  }, "\"esos medicamentos solo matan los adultos, no los huevos\""), "."));
};
const Authority = () => {
  var c = window.__PP_AUTHORITY || {};
  return React.createElement("section", {
    className: "section bg-mint",
    "data-screen-label": "07 Autoridad"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "mint"
  }, c.eyebrow || 'Fórmula respaldada'), React.createElement("h2", {
    className: "h-section"
  }, c.title || 'Diseñada con especialistas en nutrición infantil.'), React.createElement("div", {
    className: "authority"
  }, React.createElement("div", {
    className: "seal"
  }, React.createElement(Icon.Verified, null)), React.createElement("h3", null, c.seal_title || 'Aprobado para uso pediátrico'), React.createElement("p", null, c.body || 'Desarrollado con creatina monohidratada de calidad, la más estudiada para rendimiento. cionistas infantiles. Cada hierba está dosificada según el rango de edad de 3 a 12 años.'), React.createElement("div", {
    className: "credentials"
  }, React.createElement("span", {
    className: "cred"
  }, React.createElement(Icon.Check, null), " ", c.cred_1 || 'Creatina monohidratada'), React.createElement("span", {
    className: "cred"
  }, React.createElement(Icon.Check, null), " ", c.cred_2 || 'Fórmula pediátrica'), React.createElement("span", {
    className: "cred"
  }, React.createElement(Icon.Check, null), " ", c.cred_3 || 'Sin contraindicaciones')), React.createElement("div", {
    style: {
      position: 'absolute',
      right: -40,
      top: -40,
      width: 140,
      height: 140,
      borderRadius: 999,
      background: 'var(--mint)',
      opacity: 0.25,
      filter: 'blur(20px)'
    }
  }), React.createElement("div", {
    style: {
      position: 'absolute',
      left: -30,
      bottom: -30,
      width: 100,
      height: 100,
      borderRadius: 999,
      background: 'var(--pink-100)',
      opacity: 0.5,
      filter: 'blur(16px)'
    }
  })));
};
const Reviews = () => {
  const bars = [{
    s: 5,
    p: 82
  }, {
    s: 4,
    p: 12
  }, {
    s: 3,
    p: 4
  }, {
    s: 2,
    p: 1
  }, {
    s: 1,
    p: 1
  }];
  const moms = [{
    src: window.__resources.mom1,
    name: 'Andrea M.'
  }, {
    src: window.__resources.mom2,
    name: 'Diana R.'
  }, {
    src: window.__resources.mom3,
    name: 'Laura P.'
  }, {
    src: window.__resources.mom4,
    name: 'Yuli C.'
  }];
  const reviews = [{
    av: window.__resources.mom2,
    who: 'Mariana O.',
    loc: 'Bogotá',
    when: 'hace 5 días',
    title: 'Lloré en la cocina',
    body: 'Mi hijo de 5 años llevaba 6 meses sin comer. El pediatra me decía "es etapa señora". Probé las gotas y a la semana y media me dijo "ma, tengo hambre". Lloré. Lleva 3 bolsas seguidas, muy contento kilos.'
  }, {
    av: window.__resources.mom3,
    who: 'Yenni R.',
    loc: 'Medellín',
    when: 'hace 1 semana',
    title: 'Ya no creía en nada',
    body: 'Probé varias creatinas en polvo y todas terminaron guardadas. Con las gomitas llevo dos bolsas seguidas sin fallar un día. La diferencia se nota en el gym.'
  }, {
    av: window.__resources.mom4,
    who: 'Marta T.',
    loc: 'Cali',
    when: 'hace 2 semanas',
    title: 'Ahora sí soy constante 🌷',
    body: 'Yo crecí con paico y agua de ajo. Ahora uno no sabe cómo dosificar eso para los niños. Esto es exactamente lo mismo, pero medido, en gotas, sin amargo. Ya voy por la 3ª bolsa.'
  }];
  return React.createElement("section", {
    className: "section bg-cream",
    "data-screen-label": "08 Reviews"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "pink"
  }, "Rese\xF1as reales"), React.createElement("h2", {
    className: "h-section"
  }, "Lo que dicen en el gym."), React.createElement("div", {
    className: "rating-hero"
  }, React.createElement("div", {
    className: "big"
  }, "4.8"), React.createElement("div", {
    className: "stars"
  }, "\u2605\u2605\u2605\u2605\u2605"), React.createElement("div", {
    className: "count"
  }, "2.140 reseñas verificadas"), React.createElement("div", {
    className: "rating-bars"
  }, bars.map(b => React.createElement("div", {
    className: "rb",
    key: b.s
  }, React.createElement("span", null, b.s, React.createElement("span", {
    style: {
      color: 'var(--pink)'
    }
  }, "\u2605")), React.createElement("span", {
    className: "bar"
  }, React.createElement("span", {
    className: "fill",
    style: {
      width: b.p + '%'
    }
  })), React.createElement("span", null, b.p, "%"))))), React.createElement("div", {
    style: {
      marginTop: 'var(--s6)'
    }
  }, React.createElement("div", {
    style: {
      fontSize: 12,
      fontWeight: 700,
      color: 'var(--muted)',
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      marginBottom: 10
    }
  }, "Videos de mam\xE1s reales"), React.createElement("div", {
    className: "mom-strip"
  }, moms.map((m, i) => React.createElement("div", {
    className: "mom",
    key: i
  }, React.createElement("img", {
    src: m.src,
    alt: m.name
  }), React.createElement("span", {
    className: "play"
  }, "\u25B6 ", m.name.split(' ')[0]))))), React.createElement("div", {
    style: {
      marginTop: 'var(--s5)',
      fontSize: 12,
      fontWeight: 700,
      color: 'var(--muted)',
      letterSpacing: '0.08em',
      textTransform: 'uppercase'
    }
  }, "Y ahora mira esto"), React.createElement("div", {
    className: "momkids"
  }, React.createElement("div", {
    className: "momkid"
  }, React.createElement("div", {
    className: "ph",
    style: {
      backgroundImage: 'url(' + window.__resources.momkidAndrea + ')'
    }
  }), React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "nm"
  }, "Andrea M. ", React.createElement(Icon.Verified, null)), React.createElement("div", {
    className: "loc"
  }, "Bogot\xE1"), React.createElement("div", {
    className: "st"
  }, "\u2605\u2605\u2605\u2605\u2605"))), React.createElement("div", {
    className: "momkid"
  }, React.createElement("div", {
    className: "ph",
    style: {
      backgroundImage: 'url(' + window.__resources.momkidDiana + ')'
    }
  }), React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "nm"
  }, "Diana R. ", React.createElement(Icon.Verified, null)), React.createElement("div", {
    className: "loc"
  }, "Medell\xEDn"), React.createElement("div", {
    className: "st"
  }, "\u2605\u2605\u2605\u2605\u2605"))), React.createElement("div", {
    className: "momkid"
  }, React.createElement("div", {
    className: "ph",
    style: {
      backgroundImage: 'url(' + window.__resources.momkidLaura + ')'
    }
  }), React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "nm"
  }, "Laura P. ", React.createElement(Icon.Verified, null)), React.createElement("div", {
    className: "loc"
  }, "Cali"), React.createElement("div", {
    className: "st"
  }, "\u2605\u2605\u2605\u2605\u2605"))), React.createElement("div", {
    className: "momkid"
  }, React.createElement("div", {
    className: "ph",
    style: {
      backgroundImage: 'url(' + window.__resources.momkidYuli + ')'
    }
  }), React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "nm"
  }, "Yuli C. ", React.createElement(Icon.Verified, null)), React.createElement("div", {
    className: "loc"
  }, "Bucaramanga"), React.createElement("div", {
    className: "st"
  }, "\u2605\u2605\u2605\u2605\u2605")))), React.createElement("div", {
    style: {
      marginTop: 'var(--s5)'
    }
  }, reviews.map((r, i) => React.createElement("div", {
    className: "review",
    key: i
  }, React.createElement("div", {
    className: "head"
  }, React.createElement("div", {
    className: "av",
    style: {
      backgroundImage: 'url(' + r.av + ')'
    }
  }), React.createElement("div", {
    style: {
      flex: 1
    }
  }, React.createElement("div", {
    className: "who"
  }, r.who, " ", React.createElement("span", {
    className: "verif"
  }, React.createElement(Icon.Verified, null), " Verificada")), React.createElement("div", {
    className: "meta"
  }, r.loc, " \xB7 ", r.when))), React.createElement("div", {
    className: "stars"
  }, "\u2605\u2605\u2605\u2605\u2605"), React.createElement("div", {
    className: "title"
  }, r.title), React.createElement("div", {
    className: "body"
  }, r.body)))));
};
const Distributor = () => React.createElement("section", {
  className: "section tight bg-cream",
  "data-screen-label": "Distribuidor"
}, React.createElement("div", {
  className: "distrib-v2"
}, React.createElement("div", {
  className: "distrib-v2__head"
}, React.createElement("span", {
  className: "distrib-v2__seal"
}, React.createElement(Icon.Verified, null)), React.createElement("div", {
  className: "distrib-v2__title-wrap"
}, React.createElement("div", {
  className: "distrib-v2__brand"
}, "JoySpring"), React.createElement("h3", null, "Distribuidor oficial en Colombia"))), React.createElement("div", {
  className: "distrib-v2__badges"
}, React.createElement("span", {
  className: "distrib-v2__badge"
}, React.createElement(Icon.Shield, null), " Producto aut\xE9ntico"), React.createElement("span", {
  className: "distrib-v2__badge"
}, React.createElement(Icon.Box, null), " Importaci\xF3n oficial"), React.createElement("span", {
  className: "distrib-v2__badge"
}, React.createElement(Icon.Check, null), " Sin azúcar"))));
window.Sec2 = {
  NaturalVsChem,
  Authority,
  Reviews,
  Distributor
};

const {
  useState: useState3
} = React;
const Pricing = () => {
  return React.createElement("section", {
    className: "section bg-cream",
    "data-screen-label": "10 Pricing",
    id: "pricing"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "ink"
  }, "Elige tu plan"), React.createElement("h2", {
    className: "h-section"
  }, "Tu fuerza sube en 2 a 4 semanas."), React.createElement("p", {
    className: "kicker"
  }, "Sistema completo de 30 d\xEDas. Pagas al recibir."), React.createElement("div", {
    className: "prices"
  }, React.createElement("div", {
    className: "price-card"
  }, React.createElement("div", {
    className: "pkg"
  }, "1 Frasco"), React.createElement("div", {
    className: "desc"
  }, "Limpieza de 30 d\xEDas"), React.createElement("div", {
    className: "bottle"
  }, React.createElement("img", {
    src: window.__resources.bottle,
    alt: "Beast Bites bottle"
  })), React.createElement("div", {
    className: "was"
  }, (window.__PP_SETTINGS || {}).price_single_was || '$140.000'), React.createElement("div", {
    className: "now"
  }, (window.__PP_SETTINGS || {}).price_single || '$99.900'), React.createElement("div", {
    style: {
      fontSize: 11,
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, "Tratamiento de 30 d\xEDas")), React.createElement("div", {
    className: "price-card best"
  }, React.createElement("div", {
    className: "tag"
  }, React.createElement(Icon.Star, {
    style: {
      width: 11,
      height: 11
    }
  }), " M\xE1s elegido"), React.createElement("div", {
    className: "pkg"
  }, "Paga 1, lleva 2"), React.createElement("div", {
    className: "desc"
  }, "Ciclo familiar completo"), React.createElement("div", {
    className: "bottle",
    style: {
      display: 'flex',
      gap: 6,
      padding: 8
    }
  }, React.createElement("img", {
    src: window.__resources.bottle,
    alt: "bottle",
    style: {
      height: '100%',
      objectFit: 'contain'
    }
  }), React.createElement("img", {
    src: window.__resources.bottle,
    alt: "bottle",
    style: {
      height: '100%',
      objectFit: 'contain'
    }
  })), React.createElement("div", {
    className: "was"
  }, (window.__PP_SETTINGS || {}).price_duo_was || '$170.000'), React.createElement("div", {
    className: "now"
  }, (window.__PP_SETTINGS || {}).price_duo || '$104.900'), React.createElement("div", {
    style: {
      fontSize: 11,
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, "Tratamiento de 60 d\xEDas"), React.createElement("div", {
    className: "save"
  }, React.createElement(Icon.Sparkle, {
    style: {
      width: 10,
      height: 10
    }
  }), " Ahorras $120.000"))), React.createElement("div", {
    className: "bonus"
  }, React.createElement("div", {
    className: "bk"
  }, React.createElement(Icon.Doc, {
    style: {
      width: 22,
      height: 22,
      marginBottom: 4
    }
  }), "Gu\xEDa Mam\xE1 Tranquila"), React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "lab"
  }, React.createElement(Icon.Gift, {
    style: {
      width: 10,
      height: 10,
      display: 'inline',
      verticalAlign: -1
    }
  }), " Regalo incluido"), React.createElement("h4", null, "Gu\xEDa de la Mam\xE1 Tranquila"), React.createElement("p", null, "7 d\xEDas para que tu hijo vuelva a comer sin pelea."), React.createElement("div", {
    className: "pr"
  }, React.createElement("s", null, "$39.000"), "GRATIS hoy"))), React.createElement("div", {
    className: "stock-line"
  }, React.createElement("span", {
    className: "dot"
  }), " Solo quedan ", (window.__PP_SETTINGS || {}).stock_left || '20', " bolsas este mes"), React.createElement(Sec1.PrimaryCTA, null, (window.__PP_SETTINGS || {}).cta_text || 'La quiero probar'), React.createElement("div", {
    className: "pay-row"
  }, React.createElement("span", {
    className: "pay-lbl"
  }, React.createElement(Icon.Lock, null), " Pago seguro"), React.createElement("span", {
    className: "pm"
  }, "PSE"), React.createElement("span", {
    className: "pm"
  }, "Mastercard"), React.createElement("span", {
    className: "pm"
  }, "VISA"), React.createElement("span", {
    className: "pm"
  }, "Mercado Pago")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,1fr)',
      gap: 8,
      marginTop: 'var(--s5)'
    }
  }, React.createElement("div", {
    style: {
      background: '#fff',
      border: '1px solid var(--line)',
      borderRadius: 'var(--r-md)',
      padding: '14px 8px',
      textAlign: 'center'
    }
  }, React.createElement(Icon.Truck, {
    style: {
      width: 22,
      height: 22,
      color: 'var(--ink-3)',
      margin: '0 auto 4px'
    }
  }), React.createElement("div", {
    style: {
      fontSize: 12,
      fontWeight: 800,
      color: 'var(--ink)'
    }
  }, "Env\xEDo gratis"), React.createElement("div", {
    style: {
      fontSize: 10.5,
      color: 'var(--muted)',
      marginTop: 2,
      fontWeight: 500
    }
  }, "2-5 d\xEDas")), React.createElement("div", {
    style: {
      background: '#fff',
      border: '1px solid var(--line)',
      borderRadius: 'var(--r-md)',
      padding: '14px 8px',
      textAlign: 'center'
    }
  }, React.createElement(Icon.Cash, {
    style: {
      width: 22,
      height: 22,
      color: 'var(--ink-3)',
      margin: '0 auto 4px'
    }
  }), React.createElement("div", {
    style: {
      fontSize: 12,
      fontWeight: 800,
      color: 'var(--ink)'
    }
  }, "Contra entrega"), React.createElement("div", {
    style: {
      fontSize: 10.5,
      color: 'var(--muted)',
      marginTop: 2,
      fontWeight: 500
    }
  }, "Pagas al recibir")), React.createElement("div", {
    style: {
      background: '#fff',
      border: '1px solid var(--line)',
      borderRadius: 'var(--r-md)',
      padding: '14px 8px',
      textAlign: 'center'
    }
  }, React.createElement(Icon.Shield, {
    style: {
      width: 22,
      height: 22,
      color: 'var(--ink-3)',
      margin: '0 auto 4px'
    }
  }), React.createElement("div", {
    style: {
      fontSize: 12,
      fontWeight: 800,
      color: 'var(--ink)'
    }
  }, "Garant\xEDa 30 d\xEDas"), React.createElement("div", {
    style: {
      fontSize: 10.5,
      color: 'var(--muted)',
      marginTop: 2,
      fontWeight: 500
    }
  }, "100% reembolso"))));
};
const FAQ = () => {
  const items = [{
    q: '¿Es segura la creatina en gomitas?',
    a: 'Sí. Usa creatina monohidratada Creapure, la más estudiada. Sin azúcar añadida. Es el mismo ingrediente del polvo, en gomita.'
  }, {
    q: '¿Cómo se toman?',
    a: '3 gomitas al día, todos los días. A cualquier hora, antes o después de entrenar. Apto para mayores de 15 años.'
  }, {
    q: '¿En cuánto tiempo se ven resultados?',
    a: 'La creatina necesita constancia. La mayoría nota más fuerza entre la segunda y la cuarta semana. Una bolsa rinde 30 días.'
  }, {
    q: '¿Cómo se da Beast Bites?',
    a: 'Súper fácil. Te comes 3 gomitas ado en su jugo favorito. Preferiblemente por la mañana. Agita antes de cada uso.'
  }, {
    q: '¿Cómo es el pago contra entrega y el envío?',
    a: 'Pagas al transportador cuando recibes tu pedido. Envío gratis a toda Colombia. Llega entre 2 y 5 días hábiles según tu ciudad.'
  }, {
    q: '¿Qué pasa si no veo resultados?',
    a: 'Tienes 30 días de garantía. Si no funciona, te devolvemos el 100% de tu dinero. Sin preguntas. Sin trámites complicados.'
  }];
  const [open, setOpen] = useState3(0);
  return React.createElement("section", {
    className: "section bg-cream2",
    "data-screen-label": "11 FAQ"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "ink"
  }, "Preguntas frecuentes"), React.createElement("h2", {
    className: "h-section"
  }, "Resolvemos tus dudas"), React.createElement("div", {
    className: "faq"
  }, items.map((it, i) => React.createElement("button", {
    className: 'row ' + (open === i ? 'open' : ''),
    key: i,
    onClick: () => setOpen(open === i ? -1 : i)
  }, React.createElement("div", {
    className: "wrap"
  }, React.createElement("div", {
    className: "q"
  }, it.q), React.createElement("div", {
    className: "a"
  }, it.a)), React.createElement(Icon.Plus, {
    className: "ic"
  })))));
};
const Urgency = () => {
  var c = window.__PP_URGENCY || {};
  return React.createElement("section", {
    className: "urgency",
    "data-screen-label": "12 Urgency"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "pink"
  }, c.eyebrow || 'Antes de cerrar esta página'), React.createElement("h2", null, c.title || 'Cada semana cuenta.'), React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: c.p1 || 'Cada semana que pasa sin que tu hijo coma bien es una semana de crecimiento que <strong>no se recupera.</strong>'
    }
  }), React.createElement("p", null, c.p2 || 'Entre los 4 y los 8 años el cuerpo está formándose. Los nutrientes que no entran ahora, no entran nunca.'), React.createElement("div", {
    className: "guarantee"
  }, React.createElement("div", {
    className: "gi"
  }, React.createElement(Icon.Shield, null)), React.createElement("div", {
    className: "gt"
  }, c.guarantee || '30 días. Pagas al recibir. Si no funciona, te devolvemos todo.')), React.createElement(Sec1.PrimaryCTA, null, c.cta || 'La quiero ya'));
};
const Footer = () => {
  var c = window.__PP_FOOTER || {};
  return React.createElement("footer", {
    className: "footer",
    "data-screen-label": "13 Footer"
  }, React.createElement("div", {
    className: "b"
  }, c.brand || 'JoySpring · Distribuidor Colombia'), React.createElement("div", {
    className: "small",
    dangerouslySetInnerHTML: {
      __html: c.legal || 'Beast Bites™ es marca registrada.<br/>No reemplaza una dieta balanceada ni asesoría profesional.<br/>© 2026 · Todos los derechos reservados'
    }
  }));
};
const StickyBuy = ({
  onClick
}) => {
  var promo = window.__PP_PROMO || {};
  var priceNow = promo.price_now || window.__PP_SETTINGS && window.__PP_SETTINGS.price_single || '$99.900';
  var priceWas = promo.price_was || window.__PP_SETTINGS && window.__PP_SETTINGS.price_single_was || '$140.000';
  var ctaText = promo.cta_text || 'Lo quiero';
  return React.createElement("div", {
    className: "sticky-buy"
  }, React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "lab"
  }, "Beast Bites \xB7 30 d\xEDas"), React.createElement("div", {
    className: "pr"
  }, React.createElement("s", null, priceWas), priceNow)), React.createElement("button", {
    className: "cta",
    onClick: onClick
  }, ctaText, " ", React.createElement(Icon.Arrow, {
    className: "ar"
  })));
};
window.Sec3 = {
  Pricing,
  FAQ,
  Urgency,
  Footer,
  StickyBuy
};

const {
  useState: useStateH,
  useEffect: useEffectH,
  useRef: useRefH
} = React;
const MomPillV2 = () => React.createElement("div", {
  className: "mom-pill-v2"
}, React.createElement("div", {
  className: "avs"
}, React.createElement("div", {
  className: "av",
  style: {
    backgroundImage: 'url(' + window.__resources.mom1 + ')'
  }
}), React.createElement("div", {
  className: "av",
  style: {
    backgroundImage: 'url(' + window.__resources.mom2 + ')'
  }
}), React.createElement("div", {
  className: "av",
  style: {
    backgroundImage: 'url(' + window.__resources.mom3 + ')'
  }
})), React.createElement("span", null, "+8.000 colombianos"), React.createElement("span", {
  className: "star"
}, "\u2605 4.8"));
const ProductGallery = () => {
  const slides = [{
    id: 's1',
    thumb: window.__resources.heroSlide1 || window.__resources.bottle,
    type: 'image',
    src: window.__resources.heroSlide1 || window.__resources.bottle
  }, {
    id: 's2',
    thumb: window.__resources.heroSlide2 || window.__resources.heroMomKid,
    type: 'image',
    src: window.__resources.heroSlide2 || window.__resources.heroMomKid
  }, {
    id: 's3',
    thumb: window.__resources.heroSlide3 || window.__resources.momkidAndrea,
    type: 'image',
    src: window.__resources.heroSlide3 || window.__resources.momkidAndrea
  }, {
    id: 's4',
    thumb: window.__resources.heroSlide4 || window.__resources.momkidDiana,
    type: 'image',
    src: window.__resources.heroSlide4 || window.__resources.momkidDiana
  }, {
    id: 's5',
    thumb: window.__resources.heroSlide5 || window.__resources.momkidLaura,
    type: 'image',
    src: window.__resources.heroSlide5 || window.__resources.momkidLaura
  }];
  const [active, setActive] = useStateH(0);
  const stripRef = useRefH(null);
  const cur = slides[active];
  const stageRef = useRefH(null);
  const touchStart = useRefH(null);
  const onTouchStart = e => {
    touchStart.current = e.touches[0].clientX;
  };
  const onTouchEnd = e => {
    if (touchStart.current == null) return;
    const dx = e.changedTouches[0].clientX - touchStart.current;
    if (Math.abs(dx) > 40) {
      if (dx < 0) setActive(a => Math.min(slides.length - 1, a + 1));else setActive(a => Math.max(0, a - 1));
    }
    touchStart.current = null;
  };
  return React.createElement("div", {
    className: "pdp-gallery"
  }, React.createElement("div", {
    className: "pdp-stage",
    ref: stageRef,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd
  }, active === 0 && React.createElement("div", {
    className: "pdp-corner pdp-corner-l"
  }, React.createElement("span", {
    className: "pdp-best"
  }, React.createElement(Icon.Star, null), " M\xE1s vendido")), React.createElement("div", {
    className: "pdp-canvas"
  }, cur.type === 'product' && React.createElement("img", {
    className: "pdp-bottle",
    src: window.__resources.bottle,
    alt: "Beast Bites"
  }), cur.type === 'image' && React.createElement("img", {
    className: "pdp-img",
    src: cur.src,
    alt: cur.label
  })), React.createElement("div", {
    className: "pdp-dots"
  }, slides.map((_, i) => React.createElement("span", {
    key: i,
    className: 'd ' + (active === i ? 'on' : '')
  })))), React.createElement("div", {
    className: "pdp-thumbs",
    ref: stripRef
  }, slides.map((s, i) => React.createElement("div", {
    key: s.id,
    role: "button",
    tabIndex: 0,
    className: 'pdp-thumb ' + (active === i ? 'is-active' : ''),
    onClick: () => setActive(i),
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') setActive(i);
    },
    "aria-label": s.label
  }, React.createElement("img", {
    className: "ph",
    src: s.thumb,
    alt: s.label
  })))));
};
const BundleCards = ({
  selected,
  setSelected
}) => {
  const bundles = [{
    id: 'single',
    qty: '1 bolsa',
    desc: '90 gomitas · 30 días',
    now: '$99.900',
    was: '$140.000',
    saveBadge: 'Ahorras $40K',
    ribbon: null,
    extra: {
      title: 'Reto Beast 30',
      sub: 'Tu cuerpo en 30 días',
      free: 'Gratis'
    }
  }, {
    id: 'duo',
    qty: 'Paga 1, lleva 2',
    desc: '2 bolsas · 60 días',
    now: '$139.900',
    was: '$280.000',
    saveBadge: 'Ahorras $140K',
    ribbon: {
      text: 'Más vendido',
      icon: React.createElement(Icon.Star, null),
      pink: true
    },
    extra: {
      title: 'Reto Beast 30',
      sub: 'Tu cuerpo en 30 días',
      free: 'Gratis'
    }
  }];
  return React.createElement("div", {
    className: "bundles"
  }, bundles.map(b => React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: 'bundle ' + (selected === b.id ? 'is-selected' : '') + (b.id === 'duo' ? ' is-best' : ''),
    key: b.id,
    onClick: () => setSelected(b.id),
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') setSelected(b.id);
    }
  }, b.ribbon && React.createElement("span", {
    className: 'ribbon ' + (b.ribbon.pink ? 'pink' : '')
  }, b.ribbon.icon, " ", b.ribbon.text), React.createElement("span", {
    className: "radio"
  }), React.createElement("div", {
    className: "center"
  }, React.createElement("div", {
    className: "row-1"
  }, React.createElement("span", {
    className: "qty"
  }, b.qty)), React.createElement("div", {
    className: "row-2"
  }, b.desc), b.saveBadge && React.createElement("span", {
    className: "save-chip"
  }, b.saveBadge)), React.createElement("div", {
    className: "price-col"
  }, React.createElement("div", {
    className: "was"
  }, b.was), React.createElement("div", {
    className: "now"
  }, b.now)), b.extra && React.createElement("div", {
    className: "extra extra-ebook"
  }, React.createElement("div", {
    className: "ebook-mini"
  }, React.createElement("img", {
    src: window.__resources.ebookCover,
    alt: ""
  })), React.createElement("div", {
    className: "lab"
  }, React.createElement("span", {
    className: "incl"
  }, React.createElement(Icon.Gift, {
    style: {
      width: 10,
      height: 10
    }
  }), " Regalo incluido"), React.createElement("span", {
    className: "title"
  }, b.extra.title), React.createElement("small", null, b.extra.sub)), React.createElement("span", {
    className: "free"
  }, b.extra.free)))));
};
const UrgencyChip = ({
  stock = 7
}) => React.createElement("div", {
  className: "urgency-row"
}, React.createElement("div", {
  className: "urgency-chip"
}, React.createElement("span", {
  className: "dot"
}), "Solo quedan ", stock, " unidades disponibles hoy"));
const QuickBenefits = () => {
  const items = [{
    name: 'Más fuerza',
    ic: React.createElement(Icon.Bolt, null)
  }, {
    name: 'Más músculo',
    ic: React.createElement(Icon.Star, null)
  }, {
    name: 'Mejor recuperación',
    ic: React.createElement(Icon.Cycle, null)
  }, {
    name: 'Sin azúcar',
    ic: React.createElement(Icon.Leaf, null)
  }, {
    name: 'Fácil de tomar',
    ic: React.createElement(Icon.Gift, null)
  }, {
    name: 'Sin grumos',
    ic: React.createElement(Icon.Droplet, null)
  }];
  return React.createElement("div", {
    className: "quick-benefits"
  }, items.map((i, k) => React.createElement("div", {
    className: "qb",
    key: k
  }, React.createElement("span", {
    className: 'ic ' + (i.pink ? 'pink' : '')
  }, i.ic), React.createElement("span", {
    className: "nm"
  }, i.name))));
};
const MiniReview = ({
  av,
  quote,
  who,
  loc
}) => React.createElement("div", {
  className: "mini-review",
  style: {
    display: 'flex',
    gap: 14,
    alignItems: 'flex-start',
    background: '#fff',
    border: '1px solid var(--line)',
    borderRadius: 'var(--r-lg)',
    padding: 'var(--s5)',
    boxShadow: 'var(--sh-1)'
  }
}, React.createElement("div", {
  className: "av",
  style: {
    backgroundImage: `url(${av})`,
    width: 44,
    height: 44,
    minWidth: 44,
    minHeight: 44,
    borderRadius: '999px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: 'var(--mint-100)',
    flexShrink: 0,
    border: '2px solid var(--line)'
  }
}), React.createElement("div", {
  className: "body",
  style: {
    flex: 1,
    minWidth: 0
  }
}, React.createElement("div", {
  className: "stars",
  style: {
    color: 'var(--pink)',
    fontSize: 13,
    letterSpacing: 2
  }
}, "\u2605\u2605\u2605\u2605\u2605"), React.createElement("div", {
  className: "quote",
  style: {
    fontSize: 14,
    color: 'var(--ink)',
    fontWeight: 600,
    lineHeight: 1.5,
    margin: '8px 0 10px',
    letterSpacing: '-0.005em'
  }
}, quote), React.createElement("div", {
  className: "meta",
  style: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 12,
    color: 'var(--muted)',
    fontWeight: 600,
    flexWrap: 'wrap'
  }
}, React.createElement("span", {
  className: "nm",
  style: {
    color: 'var(--ink)',
    fontWeight: 800
  }
}, who), React.createElement("span", {
  className: "sep",
  style: {
    color: 'var(--muted-2)'
  }
}, "\xB7"), React.createElement("span", null, loc), React.createElement("span", {
  className: "verif",
  style: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 3,
    color: 'var(--mint-600)',
    fontWeight: 700,
    fontSize: 11,
    marginLeft: 'auto'
  }
}, React.createElement(Icon.Verified, null), " Verificada"))));
const MiniFAQ = ({
  items = []
}) => {
  const [open, setOpen] = useStateH(0);
  return React.createElement("div", {
    className: "mini-faq"
  }, items.map((it, i) => React.createElement("button", {
    key: i,
    className: 'row ' + (open === i ? 'open' : ''),
    onClick: () => setOpen(open === i ? -1 : i),
    type: "button"
  }, React.createElement("div", {
    className: "wrap"
  }, React.createElement("div", {
    className: "q"
  }, it.q), React.createElement("div", {
    className: "a",
    dangerouslySetInnerHTML: {
      __html: it.a
    }
  })), React.createElement(Icon.Plus, {
    className: "ic"
  }))));
};
const Divider = ({
  text = 'Elige tu plan ideal'
}) => React.createElement("div", {
  className: "divider"
}, React.createElement("span", {
  className: "line"
}), React.createElement("span", {
  className: "text"
}, React.createElement("span", {
  className: "star"
}, "\u2726"), " ", text, " ", React.createElement("span", {
  className: "star"
}, "\u2726")), React.createElement("span", {
  className: "line"
}));
const TrustBadges = () => React.createElement("div", {
  className: "trust-badges"
}, React.createElement("div", {
  className: "trust-badge"
}, React.createElement("span", {
  className: "ic"
}, React.createElement(Icon.Truck, null)), React.createElement("span", {
  className: "nm"
}, "Env\xEDo gratis"), React.createElement("span", {
  className: "dot"
}, "\xB7"), React.createElement("span", {
  className: "sub"
}, "2-5 d\xEDas h\xE1biles")), React.createElement("div", {
  className: "trust-badge"
}, React.createElement("span", {
  className: "ic"
}, React.createElement(Icon.Cash, null)), React.createElement("span", {
  className: "nm"
}, "Contraentrega"), React.createElement("span", {
  className: "dot"
}, "\xB7"), React.createElement("span", {
  className: "sub"
}, "Pagas al recibir")), React.createElement("div", {
  className: "trust-badge"
}, React.createElement("span", {
  className: "ic"
}, React.createElement(Icon.Shield, null)), React.createElement("span", {
  className: "nm"
}, "Garant\xEDa 30 d\xEDas"), React.createElement("span", {
  className: "dot"
}, "\xB7"), React.createElement("span", {
  className: "sub"
}, "100% reembolso")));
const HeroV2 = () => {
  const [selected, setSelected] = useStateH('duo');
  const qty = selected === 'duo' ? 2 : 1;
  const hs = window.__PP_SETTINGS || {};
  useEffectH(() => {
    var s = window.__PP_SETTINGS || {};
    var now = selected === 'duo' ? s.price_duo || '$139.900' : s.price_single || '$99.900';
    var was = selected === 'duo' ? s.price_duo_was || '$280.000' : s.price_single_was || '$140.000';
    window.__PP_SELECTED = {
      qty: qty,
      now: now,
      was: was
    };
    try {
      window.dispatchEvent(new CustomEvent('pp-bundle-changed', {
        detail: window.__PP_SELECTED
      }));
    } catch (e) {}
  }, [selected]);
  return React.createElement("section", {
    className: "hero-v2",
    "data-screen-label": "01 Hero"
  }, React.createElement(ProductGallery, null), React.createElement("div", {
    className: "hero-edit"
  }, React.createElement("div", {
    className: "hero-edit__badge"
  }, React.createElement("span", {
    className: "trophy"
  }, "\uD83C\uDFC6"), React.createElement("span", null, hs.hero_badge || '#1 en creatina en gomitas')), React.createElement("div", {
    className: "hero-edit__proof"
  }, React.createElement("div", {
    className: "avs"
  }, React.createElement("img", {
    className: "av",
    src: window.__resources.mom1,
    alt: ""
  }), React.createElement("img", {
    className: "av",
    src: window.__resources.mom2,
    alt: ""
  }), React.createElement("img", {
    className: "av",
    src: window.__resources.mom3,
    alt: ""
  })), React.createElement("span", null, hs.hero_proof || '+8.000 colombianos prefieran en', " ", React.createElement("strong", null, "Beast Bites", React.createElement("sup", null, "\u2122")))), React.createElement("a", {
    href: "#reviews",
    className: "hero-edit__rating",
    onClick: e => {
      e.preventDefault();
      const t = document.getElementById('reviews');
      if (t) t.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    },
    "aria-label": "Ver rese\xF1as"
  }, React.createElement("span", {
    className: "stars"
  }, "\u2605\u2605\u2605\u2605\u2605"), React.createElement("strong", null, "4.8/5"), React.createElement("span", {
    className: "count"
  }, "(2.140 reseñas verificadas)")), React.createElement("h1", {
    className: "hero-edit__h1"
  }, hs.hero_title_1 || 'La creatina que', " ", React.createElement("span", {
    className: "accent",
    dangerouslySetInnerHTML: { __html: hs.hero_title_2 || 'sí vas<br>a terminar.' }
  })), React.createElement("p", {
    className: "hero-edit__sub"
  }, hs.hero_sub || 'Creatina en gomitas de frambuesa azul — con 3 al día ya está. Sin shaker, sin grumos.')), React.createElement("div", {
    className: "h-block"
  }, React.createElement(QuickBenefits, null)), React.createElement(Divider, {
    text: "Aprovecha el descuento de hoy"
  }), React.createElement(BundleCards, {
    selected: selected,
    setSelected: setSelected
  }), React.createElement("div", {
    className: "hero-buy-block"
  }, React.createElement(UrgencyChip, {
    stock: 7
  }), React.createElement(Sec1.PrimaryCTA, {
    qty: qty
  }, "La quiero probar"), React.createElement("div", {
    className: "cta-trust"
  }, React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#1565c0",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
  }), React.createElement("path", {
    d: "M9 12l2 2 4-4"
  })), "Env\xEDo Gratis Hoy ", React.createElement("span", {
    className: "cta-trust-dot"
  }, "\xB7"), " Pagas al recibir"), React.createElement("div", {
    className: "pay-bar"
  }, React.createElement("span", {
    className: "lbl"
  }, React.createElement(Icon.Lock, null), " Pago seguro"), React.createElement("span", {
    className: "brands"
  }, React.createElement("span", {
    className: "br",
    "aria-label": "Mercado Pago",
    title: "Mercado Pago"
  }, React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0969/1453/8862/files/mercado-pago-conta-digital.webp?v=1780023760",
    alt: "Mercado Pago"
  })), React.createElement("span", {
    className: "br",
    "aria-label": "Mastercard",
    title: "Mastercard"
  }, React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0969/1453/8862/files/Mastercard_2019_logo_2.svg?v=1780023759",
    alt: "Mastercard"
  })), React.createElement("span", {
    className: "br",
    "aria-label": "VISA",
    title: "VISA"
  }, React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0969/1453/8862/files/Visa_Inc__logo__2021_present__svg.png?v=1780023760",
    alt: "VISA"
  })), React.createElement("span", {
    className: "br",
    "aria-label": "PSE",
    title: "PSE"
  }, React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0969/1453/8862/files/logo-pse-300x300-1.png?v=1780023788",
    alt: "PSE"
  })))), React.createElement(MiniReview, {
    av: window.__resources.miniRevAv || window.__resources.mom2,
    quote: window.__PP_SETTINGS && window.__PP_SETTINGS.mini_review_quote || "A las 2 semanas con Beast Bites volvió a pedir la proteína solo. Ojalá lo hubiera encontrado antes.",
    who: window.__PP_SETTINGS && window.__PP_SETTINGS.mini_review_who || "Yuliana R.",
    loc: window.__PP_SETTINGS && window.__PP_SETTINGS.mini_review_loc || "Bucaramanga"
  })), React.createElement("div", {
    style: {
      marginTop: 'var(--s5)'
    }
  }, React.createElement(TrustBadges, null)), React.createElement(MiniFAQ, {
    items: function () {
      var s = window.__PP_SETTINGS || {};
      var def = [{
        q: '¿Cuánto tiempo y cuántas gotas se dan?',
        a: 'Se da 3 gomitas al día (aprox. 1 ml) mezclado en el jugo o agua. Un frasco dura 30 días — el ciclo completo recomendado es 2 frascos (60 días) para asegurar que se eliminen los huevos y los adultos.'
      }, {
        q: '¿Desde qué edad sirve?',
        a: 'Desde los 2 años. Para niños menores de 2 años consulta con tu pediatra antes de usar.'
      }, {
        q: 'Ingredientes',
        a: '<ul style="list-style:none;padding:0;margin:0;display:grid;gap:6px"><li><strong>Cáscara negra de nogal</strong> — limpia el intestino de forma suave y profunda</li><li><strong>Ajenjo</strong> — ayuda a expulsar lo que no debería estar ahí</li><li><strong>Clavo de olor</strong> — evita que los huevos lleguen a desarrollarse</li><li><strong>Semilla de papaya</strong> — los debilita para que el cuerpo los elimine fácilmente</li><li><strong>Ajo</strong> — crea un ambiente donde no pueden sobrevivir</li><li><strong>Jengibre</strong> — calma la irritación y ayuda a que el intestino se recupere</li><li><strong>Aceite de orégano</strong> — limpia bacterias y organismos no deseados de forma natural</li><li><strong>Aceite de semilla de calabaza</strong> — rico en ácidos grasos que nutren y protegen el intestino</li><li><strong>Hoja de olivo</strong> — fortalece las defensas para que no vuelvan a aparecer</li></ul>'
      }, {
        q: 'Información de Envío',
        a: 'Llega en 2 a 5 días hábiles a cualquier ciudad de Colombia con envío 100% gratis. Puedes pagar contra entrega cuando llegue a tu puerta, o con Mercado Pago si prefieres pagar antes. Tu pedido está 100% garantizado.'
      }];
      var items = [];
      for (var i = 1; i <= 5; i++) {
        var q = s['mfaq_q' + i];
        var a = s['mfaq_a' + i];
        if (q && a) items.push({
          q,
          a
        });
      }
      return items.length ? items : def;
    }()
  }), React.createElement("div", { className: "mini-review-desktop" }, React.createElement(MiniReview, {
    av: window.__resources.miniRevAv || window.__resources.mom2,
    quote: window.__PP_SETTINGS && window.__PP_SETTINGS.mini_review_quote || "A las 2 semanas con Beast Bites volvió a pedir la proteína solo. Ojalá lo hubiera encontrado antes.",
    who: window.__PP_SETTINGS && window.__PP_SETTINGS.mini_review_who || "Yuliana R.",
    loc: window.__PP_SETTINGS && window.__PP_SETTINGS.mini_review_loc || "Bucaramanga"
  })));
};
const LifestyleCarousel = () => {
  const cfg = window.__PP_LIFESTYLE || {};
  const r = window.__resources || {};
  const srcs = [cfg.img1 || r.momkidAndrea, cfg.img2 || r.momkidLaura, cfg.img3 || r.momkidDiana, cfg.img4 || r.momkidYuli, cfg.img5 || r.mom3, cfg.img6 || r.mom4].filter(Boolean);
  const base = srcs.length ? srcs : [r.bottle].filter(Boolean);
  const track = [...base, ...base, ...base, ...base];
  return React.createElement("section", {
    className: "section tighter bg-cream2",
    "data-screen-label": "Lifestyle"
  }, React.createElement("div", {
    className: "lifestyle-marquee"
  }, React.createElement("h3", null, "\xDAnete a ", React.createElement("span", {
    className: "accent"
  }, "+8.000 personas"), " que ya la prefieren."), React.createElement("div", {
    className: "marquee"
  }, React.createElement("div", {
    className: "marquee__track"
  }, track.map((src, i) => React.createElement("div", {
    className: "m-card",
    key: i
  }, React.createElement("img", {
    className: "ph",
    src: src,
    alt: "",
    loading: "lazy"
  }))))), React.createElement("div", {
    className: "caption"
  }, "La que sí terminas. Sin excusas. Deber\xEDa ser.")));
};
const EmotionalCTA = ({
  label = 'La quiero probar',
  title,
  micro = 'Únete a +8.000 colombianos',
  cta = 'La quiero ya',
  bg = 'cream'
}) => React.createElement("section", {
  className: 'section emo-wrap bg-' + bg,
  "data-screen-label": "CTA emocional"
}, React.createElement("div", {
  className: "emo-cta"
}, label && React.createElement("div", {
  className: "label"
}, label), React.createElement("h3", null, title), React.createElement("div", {
  className: "micro"
}, React.createElement("span", {
  className: "avs"
}, React.createElement("span", {
  className: "av",
  style: {
    backgroundImage: 'url(' + window.__resources.mom1 + ')'
  }
}), React.createElement("span", {
  className: "av",
  style: {
    backgroundImage: 'url(' + window.__resources.mom2 + ')'
  }
}), React.createElement("span", {
  className: "av",
  style: {
    backgroundImage: 'url(' + window.__resources.mom3 + ')'
  }
})), React.createElement("span", null, micro)), React.createElement(Sec1.PrimaryCTA, null, cta), React.createElement("div", {
  className: "cta-trust"
}, React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#1565c0",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
}), React.createElement("path", {
  d: "M9 12l2 2 4-4"
})), "Garant\xEDa 30 d\xEDas ", React.createElement("span", {
  className: "cta-trust-dot"
}, "\xB7"), " Pagas al recibir")));
const ReviewsV2 = () => {
  const r = window.__resources || {};
  const rv = window.__PP_REVIEWS || {};
  const defaultCarousel = [{
    src: r.momkidAndrea,
    nm: 'Andrea M.',
    ci: 'Bogotá',
    qt: 'Más fuerza en el gym.',
    when: 'hace 2 semanas',
    body: 'Mi hija de 4 años llevaba meses sin tocar la comida. Empezamos con 3 gomitas en su jugo de naranja cada mañana. A los 10 días me pidió arroz por su cuenta. Hoy se sienta en la mesa sin que tenga que rogarle.'
  }, {
    src: r.momkidDiana,
    nm: 'Diana R.',
    ci: 'Medellín',
    qt: 'Aguanto más reps.',
    when: 'hace 1 mes',
    body: 'Lo que más me sorprendió fue el aguante. Desde la tercera semana termino el entreno completo sin bajar el peso.'
  }, {
    src: r.momkidYuli,
    nm: 'Yuli C.',
    ci: 'Bucaramanga',
    qt: 'Mi esposo no creía. Ahora sí.',
    when: 'hace 6 semanas',
    stars: 4,
    body: 'Mi esposo decía que era plata botada. Compré el primer frasco a escondidas. A las 3 semanas él mismo me preguntó qué le estábamos dando al niño porque lo veía con más energía. Ya pidió que pidamos el duo.'
  }, {
    src: r.momkidLaura,
    nm: 'Laura P.',
    ci: 'Cali',
    qt: 'Por fin soy constante.',
    when: 'hace 1 mes',
    body: 'Tengo el corazón apretado escribiendo esto. Mi hijo de 5 años repitió plato del almuerzo por primera vez en 2 años. Llevábamos meses con vitaminas y nada. Las gotas de verdad funcionan.'
  }, {
    src: rv.img5 || r.mom1,
    nm: 'Sofía J.',
    ci: 'Barranquilla',
    qt: 'Tres bolsas seguidas.',
    when: 'hace 2 meses',
    body: 'Llevaba años comprando polvo y dejándolo a la mitad. Con las gomitas ya voy en la tercera bolsa seguida. Es lo único que he logrado mantener.'
  }, {
    src: rv.img6 || r.mom3,
    nm: 'Camilo R.',
    ci: 'Bogotá',
    qt: 'Sin más rabietas con la comida.',
    when: 'hace 2 meses',
    body: 'Las comidas eran un campo de batalla. Llanto, pataletas, platos al piso. Hoy mi hijo se sienta solo, come en silencio y termina su plato. No es magia, es que por fin tiene hambre real.'
  }, {
    src: rv.img7,
    nm: 'Laura V.',
    ci: 'Bogotá',
    qt: 'Mi cambio en 2 meses.',
    when: 'hace 2 meses',
    body: 'Comparto mi antes y después sin filtros. Nunca había sido constante con la creatina hasta que probé las gomitas. Se me hizo fácil no fallar y se nota en el abdomen y en la fuerza.'
  }, {
    src: rv.img8,
    nm: 'Julián R.',
    ci: 'Medellín',
    qt: 'Este es mi progreso real.',
    when: 'hace 2 meses',
    body: 'Con el polvo siempre lo dejaba a la mitad, con las gomitas por fin fui juicioso todos los días. Subí fuerza y bajé barriga, el cambio habla solo.'
  }];
  const carousel = defaultCarousel.map((item, i) => {
    const n = i + 1;
    return {
      src: rv['img' + n] || item.src,
      nm: rv['r' + n + '_nm'] || item.nm,
      ci: rv['r' + n + '_ci'] || item.ci,
      qt: rv['r' + n + '_qt'] || item.qt,
      when: item.when,
      stars: item.stars || 5,
      body: rv['r' + n + '_body'] || item.body,
      isBA: n >= 7
    };
  }).filter(c => c.src);
  const carouselOrdered = (() => {
    const normal = carousel.filter(c => !c.isBA);
    const bas = carousel.filter(c => c.isBA);
    if (bas.length < 2 || normal.length < 6) return carousel;
    return [normal[0], normal[1], bas[0], normal[2], normal[3], normal[4], bas[1], normal[5]];
  })();
  const defaultDetailed = [{
    av: window.__resources.mom2,
    nm: 'Mariana O.',
    loc: 'Bogotá',
    when: 'hace 5 días',
    title: 'Lloré en la cocina',
    body: 'Mi hijo de 5 años llevaba 6 meses sin comer. Lo llevé al pediatra 2 veces, "es etapa señora". Probé las gotas y a la semana y media me dijo "ma, tengo hambre". Lloré. Lleva 3 bolsas seguidas, muy contento kilos.'
  }, {
    av: window.__resources.mom3,
    nm: 'Yenni R.',
    loc: 'Medellín',
    when: 'hace 1 semana',
    title: 'Ya no creía en nada',
    body: 'Probé varias creatinas en polvo y todas terminaron guardadas. Con las gomitas llevo dos bolsas seguidas sin fallar un día. La diferencia se nota en el gym.'
  }, {
    av: window.__resources.mom4,
    nm: 'Marta T.',
    loc: 'Cali',
    when: 'hace 2 semanas',
    stars: 4,
    title: 'Ahora sí soy constante 🌷',
    body: 'Yo crecí con paico y agua de ajo. Ahora uno no sabe cómo dosificar eso para los niños. Esto es exactamente lo mismo, pero medido, en gotas, sin amargo. Ya voy por la 3ª bolsa.'
  }, {
    av: window.__resources.mom1,
    nm: 'Carmen J.',
    loc: 'Pereira',
    when: 'hace 3 semanas',
    title: 'Sin tanta pelea 😭',
    body: 'Mi hijo volvió a comer sin tanta pelea. Lo mezclo en su jugo de naranja y ni se da cuenta. La paz que se siente en casa no tiene precio.'
  }, {
    av: window.__resources.mom2,
    nm: 'Paola V.',
    loc: 'Cartagena',
    when: 'hace 1 mes',
    title: 'Mi pediatra lo aprobó',
    body: 'Le llevé el frasco a la pediatra y revisó los ingredientes. Me dijo que las hierbas son buenas y la dosis es correcta para su edad. Llevamos 2 frascos y la diferencia es enorme.'
  }, {
    av: window.__resources.mom4,
    nm: 'Adriana K.',
    loc: 'Bogotá',
    when: 'hace 1 mes',
    title: 'Dejó de descansar',
    body: 'Lo que más me preocupaba era el descansar de dientes en la noche. Desde el día 10 paró. Y empezó a tener apetito real, no de paquetes. Vale cada peso.'
  }, {
    av: window.__resources.mom3,
    nm: 'Sofía L.',
    loc: 'Barranquilla',
    when: 'hace 1 mes',
    title: 'Mi hijo de 4 lo toma feliz',
    body: 'Pensé que iba a ser pelea, pero le pongo el gomita en su yogurt de la mañana y se lo toma sin chistar. A las 2 semanas ya pedía repetir el plato del almuerzo.'
  }, {
    av: window.__resources.mom2,
    nm: 'Diana R.',
    loc: 'Medellín',
    when: 'hace 1 mes',
    title: 'Vale cada peso',
    body: 'Compré el duo. Voy en el segundo frasco. Mi hija de 6 años duerme corrido, no se levanta a entrenar, come las 3 comidas. Mi esposo —que es escéptico— me dijo que lo siguiéramos comprando.'
  }, {
    av: window.__resources.mom1,
    nm: 'Verónica A.',
    loc: 'Bogotá',
    when: 'hace 2 meses',
    title: 'Cambió la energía de la casa',
    body: 'No solo es lo que pasó con mi hijo —que ya come bien— sino lo que pasó con nosotros como familia. Ya no peleamos en la mesa. Las cenas vuelven a ser tranquilas. Eso es invaluable.'
  }, {
    av: window.__resources.mom4,
    nm: 'Catalina F.',
    loc: 'Bucaramanga',
    when: 'hace 2 meses',
    title: 'Mi suegra preguntó qué le daba 😂',
    body: 'Mi suegra llegó de visita y me preguntó qué le estaba dando al niño porque lo veía más despierto, comiendo, jugando. Le mostré el frasco y se llevó uno para su otro nieto.'
  }, {
    av: window.__resources.mom3,
    nm: 'Luisa G.',
    loc: 'Cali',
    when: 'hace 2 meses',
    title: 'Después de 4 años buscando',
    body: 'Mi hijo es de comer poquito desde que cumplió 2 años. Probé vitaminas, batidos, todo. Esto es lo único que de verdad le devolvió el hambre. Ya no me angustio en cada comida.'
  }, {
    av: window.__resources.mom2,
    nm: 'Andrea V.',
    loc: 'Ibagué',
    when: 'hace 2 meses',
    title: 'Sin alcohol y eso me gusta',
    body: 'Lo que me decidió fue que no tiene alcohol. Otros productos que probé sí tenían y no quería darle eso a mi hijo de 5. Este lo toma feliz mezclado en su jugo de manzana.'
  }, {
    av: window.__resources.mom1,
    nm: 'Natalia M.',
    loc: 'Cartagena',
    when: 'hace 2 meses',
    title: '+1.5 kg en 3 semanas',
    body: 'Mi hijo estaba bajo de peso según el pediatra. Empezamos las gotas y al mes le tomé el peso: 1.5 kg arriba. La pediatra me preguntó qué cambió y le conté de las gotas. Pidió la fórmula.'
  }, {
    av: window.__resources.mom4,
    nm: 'Carolina P.',
    loc: 'Bogotá',
    when: 'hace 3 meses',
    title: 'La paz mental no tiene precio',
    body: 'Trabajo todo el día y vivía con la angustia de "no comió otra vez". Desde que arrancamos esto, las nanas me mandan fotos del plato vacío. Esa tranquilidad me cambia la semana.'
  }, {
    av: window.__resources.mom3,
    nm: 'Paulina E.',
    loc: 'Medellín',
    when: 'hace 3 meses',
    title: 'Más activo en el colegio',
    body: 'La profe me dijo que lo notaba más concentrado, menos cansado en clase. Yo solo había cambiado las gotas. Compré el segundo frasco al día siguiente.'
  }, {
    av: window.__resources.mom2,
    nm: 'Diana C.',
    loc: 'Tunja',
    when: 'hace 3 meses',
    title: 'Recomendado por mi prima',
    body: 'Una prima en Bogotá me lo recomendó porque a su hijo le funcionó. Yo desconfiaba. Lo pedí contraentrega para no arriesgar plata. Llegó perfecto. Llevamos 40 días y volveré a pedir.'
  }, {
    av: window.__resources.mom1,
    nm: 'Tatiana R.',
    loc: 'Pereira',
    when: 'hace 3 meses',
    title: 'Sin rabietas en las comidas',
    body: 'Antes lloraba con cada plato. Ahora se Antes odiaba prepararme el polvo. Con las gomitas soy constante. Llevo 25 días y por fin me sobra.'
  }, {
    av: window.__resources.mom4,
    nm: 'Ángela B.',
    loc: 'Neiva',
    when: 'hace 3 meses',
    title: 'Dejó de pedirme dulce',
    body: 'Antes solo quería paquete y gomas. Ahora pide fruta, pide arroz, pide carne. No sabía que el antojo de dulce podía ser eso. Las hierbas le calmaron el músculo.'
  }, {
    av: window.__resources.mom3,
    nm: 'Marcela O.',
    loc: 'Manizales',
    when: 'hace 4 meses',
    title: 'Los 30 días valieron',
    body: 'Al inicio pensé que no iba a funcionar tan rápido. Al día 18 ya notaba la diferencia. Al día 30 era otro niño. Estoy pidiendo el segundo para mantener la protección por 6 meses como dice la guía.'
  }, {
    av: window.__resources.mom2,
    nm: 'Beatriz S.',
    loc: 'Bogotá',
    when: 'hace 4 meses',
    title: 'Para mis dos hijos',
    body: 'Tengo 2 niños, uno de 5 y otra de 8. A los dos les arrancó hambre. Estoy ahorrando con el pack de 2 frascos y me sigue saliendo más barato que cualquier multivitamínico de farmacia.'
  }, {
    av: window.__resources.mom1,
    nm: 'Lorena J.',
    loc: 'Cali',
    when: 'hace 4 meses',
    title: 'No lo he vuelto a dejar',
    body: 'Antes empezaba y a la semana lo dejaba botado. Con las gomitas y la guía gratis llevo 2 meses seguidos sin fallar un día. Es la primera vez que de verdad me queda el hábito.'
  }, {
    av: window.__resources.mom4,
    nm: 'Isabel V.',
    loc: 'Bucaramanga',
    when: 'hace 4 meses',
    title: 'El envío llegó al día siguiente',
    body: 'Pedí en la mañana y al día siguiente ya tenía el frasco en la casa. Pagué al transportador, sin problemas. Para mí eso ya valió la primera compra antes de probarlo.'
  }, {
    av: window.__resources.mom3,
    nm: 'Karen P.',
    loc: 'Barranquilla',
    when: 'hace 5 meses',
    title: 'Recuperó el sueño completo',
    body: 'Lo más fuerte fue el sueño. Dejó de levantarse a la madrugada, dejó de descansar. Yo también descanso ahora. No me había dado cuenta cuánto me agotaba.'
  }, {
    av: window.__resources.mom2,
    nm: 'Mónica F.',
    loc: 'Bogotá',
    when: 'hace 5 meses',
    title: 'A mi prima también le funcionó',
    body: 'Le pasé la página a mi prima y a su hijo de 7 también le sirvió. Ya somos varios en el gym usándolo. Como un secreto entre panas del gym.'
  }, {
    av: window.__resources.mom1,
    nm: 'Pilar M.',
    loc: 'Armenia',
    when: 'hace 5 meses',
    title: 'Sin pelea en el desayuno',
    body: 'Le pongo el gomita en su leche con cocoa de la mañana. Se la toma sin notar nada. Antes el desayuno era una pelea de 40 minutos. Ahora son 10.'
  }, {
    av: window.__resources.mom4,
    nm: 'Daniela H.',
    loc: 'Medellín',
    when: 'hace 5 meses',
    title: 'Vale por el ebook también',
    body: 'La guía Fuerza Real que viene gratis está muy completa. Trae la rutina semana a semana y cómo volver el hábito automático. Eso solo ya vale la compra.'
  }, {
    av: window.__resources.mom3,
    nm: 'Camila T.',
    loc: 'Cartagena',
    when: 'hace 6 meses',
    title: 'Pediré otra ronda en 6 meses',
    body: 'La fórmula dice que protege 6 meses y por ahora va bien. Voy a pedir otra ronda para mantenerlo, aunque ya come sin problema. Prefiero prevenir.'
  }, {
    av: window.__resources.mom2,
    nm: 'Mariana E.',
    loc: 'Bogotá',
    when: 'hace 6 meses',
    title: 'Mi hijo de 9 también',
    body: 'Pensé que era solo para chiquitos. Me confirmaron que sirve hasta los 12. Mi hijo mayor también lo tomó y le mejoró el ánimo y el apetito en el almuerzo.'
  }, {
    av: window.__resources.mom1,
    nm: 'Juliana G.',
    loc: 'Pasto',
    when: 'hace 6 meses',
    title: 'La mejor compra del año',
    body: 'Soy estudiante y entreno, no es fácil decidir gastar en algo así. Pero esto cambió la dinámica de la casa. Si tuviera que escoger una sola compra del año, sería esta.'
  }, {
    av: window.__resources.mom4,
    nm: 'Sandra L.',
    loc: 'Bogotá',
    when: 'hace 6 meses',
    title: 'Lo recomendé en el grupo del gym',
    body: 'En el chat del colegio puse la foto del frasco y al día siguiente 5 panas más la habían pedido. Todas con resultado. Como un boca a boca entre los del gym.'
  }];
  const detailed = window.__PP_DETAILED && window.__PP_DETAILED.length ? window.__PP_DETAILED.map(d => ({
    av: window.__resources['mom' + (d._i % 4 + 1)],
    img: d.img || null,
    nm: d.nm || 'Mamá',
    loc: d.loc || 'Colombia',
    when: d.when || 'hace poco',
    stars: d.stars || 5,
    title: d.title || '',
    body: d.body || ''
  })) : defaultDetailed;
  const [openReview, setOpenReview] = useStateH(null);
  useEffectH(() => {
    if (openReview) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [openReview]);
  const stripData = [...carouselOrdered, ...carouselOrdered, ...carouselOrdered, ...carouselOrdered];
  const PER_PAGE = typeof window !== 'undefined' && window.innerWidth >= 900 ? 4 : 3;
  const [page, setPage] = useStateH(0);
  const totalPages = Math.ceil(detailed.length / PER_PAGE);
  const [transitioning, setTransitioning] = useStateH(false);
  const pagerRef = useRefH(null);
  const changePage = newPage => {
    if (newPage === page || transitioning) return;
    var anchorBefore = pagerRef.current ? pagerRef.current.getBoundingClientRect().top : null;
    setTransitioning(true);
    setTimeout(() => {
      setPage(newPage);
      requestAnimationFrame(() => {
        if (anchorBefore != null && pagerRef.current) {
          var anchorAfter = pagerRef.current.getBoundingClientRect().top;
          var delta = anchorAfter - anchorBefore;
          if (delta !== 0) window.scrollBy({
            top: delta,
            behavior: 'instant'
          });
        }
        requestAnimationFrame(() => {
          setTransitioning(false);
        });
      });
    }, 180);
  };
  const visibleReviews = detailed.slice(page * PER_PAGE, (page + 1) * PER_PAGE);
  const Stars = ({
    n = 5
  }) => {
    const arr = [];
    for (let i = 0; i < 5; i++) {
      arr.push(React.createElement("svg", {
        key: i,
        viewBox: "0 0 20 20",
        width: "13",
        height: "13",
        style: {
          display: 'inline-block'
        }
      }, React.createElement("path", {
        d: "M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L10 14.9 4.8 17.7l1-5.9L1.5 7.7l5.9-.8L10 1.5z",
        fill: i < n ? 'var(--pink)' : 'rgba(241,107,167,0.18)',
        stroke: i < n ? 'var(--pink)' : 'rgba(241,107,167,0.25)',
        strokeWidth: "0.8",
        strokeLinejoin: "round"
      })));
    }
    return React.createElement("span", {
      className: "stars-svg"
    }, arr);
  };
  return React.createElement("section", {
    className: "section bg-cream2",
    id: "reviews",
    "data-screen-label": "Reviews"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "pink"
  }, "Rese\xF1as reales"), React.createElement("h2", {
    className: "h-section",
    style: {
      marginBottom: 2
    }
  }, "Lo que dicen en el gym."), React.createElement("p", {
    className: "kicker reviews-kicker",
    style: {
      marginTop: 2
    }
  }, "4.8 \xB7 2.140 reseñas verificadas"), React.createElement("div", {
    className: "rating-hero",
    style: {
      padding: 'var(--s5) var(--s5)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 14,
      marginBottom: 'var(--s4)'
    }
  }, React.createElement("div", null, React.createElement("div", {
    className: "big",
    style: {
      fontSize: 42
    }
  }, "4.8"), React.createElement("div", {
    style: {
      marginTop: 2
    }
  }, React.createElement(Stars, {
    n: 5
  })), React.createElement("div", {
    className: "count"
  }, "2.140 reseñas")), React.createElement("div", {
    className: "rating-bars",
    style: {
      flex: 1,
      marginTop: 0
    }
  }, [{
    s: 5,
    p: 82
  }, {
    s: 4,
    p: 12
  }, {
    s: 3,
    p: 4
  }, {
    s: 2,
    p: 1
  }, {
    s: 1,
    p: 1
  }].map(b => React.createElement("div", {
    className: "rb",
    key: b.s
  }, React.createElement("span", null, b.s, React.createElement("span", {
    style: {
      color: 'var(--pink)'
    }
  }, "\u2605")), React.createElement("span", {
    className: "bar"
  }, React.createElement("span", {
    className: 'fill rb-s' + b.s
  })), React.createElement("span", null, b.p, "%")))))), React.createElement("div", {
    className: "review-marquee",
    "aria-label": "Rese\xF1as verificadas"
  }, React.createElement("div", {
    className: "review-marquee__track"
  }, stripData.map((c, i) => React.createElement("button", {
    type: "button",
    className: "rev-card",
    key: i,
    onClick: () => setOpenReview(c),
    "aria-label": `Leer reseña de ${c.nm}`
  }, React.createElement("div", {
    className: "ph",
    style: {
      backgroundImage: `url(${c.src})`
    }
  }), React.createElement("div", {
    className: "meta"
  }, React.createElement("div", {
    className: "nm"
  }, c.nm, " ", React.createElement(Icon.Verified, null)), React.createElement("div", {
    className: "ci"
  }, c.ci), React.createElement(Stars, {
    n: c.stars || 5
  }), React.createElement("div", {
    className: "qt"
  }, c.qt)))))), openReview && React.createElement("div", {
    className: "rev-modal",
    onClick: () => setOpenReview(null),
    role: "dialog",
    "aria-modal": "true"
  }, React.createElement("div", {
    className: "rev-modal__card",
    onClick: e => e.stopPropagation()
  }, React.createElement("button", {
    type: "button",
    className: "rev-modal__close",
    onClick: () => setOpenReview(null),
    "aria-label": "Cerrar"
  }, React.createElement("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.4",
    strokeLinecap: "round"
  }, React.createElement("path", {
    d: "M6 6l12 12M18 6L6 18"
  }))), React.createElement("div", {
    className: "rev-modal__hero",
    style: {
      backgroundImage: `url(${openReview.src})`
    }
  }, React.createElement("div", {
    className: "rev-modal__overlay"
  }), React.createElement("div", {
    className: "rev-modal__veri"
  }, React.createElement(Icon.Verified, null), " Compra verificada")), React.createElement("div", {
    className: "rev-modal__body"
  }, React.createElement(Stars, {
    n: 5
  }), React.createElement("div", {
    className: "rev-modal__name"
  }, openReview.nm), React.createElement("div", {
    className: "rev-modal__meta"
  }, openReview.ci, " \xB7 ", openReview.when), React.createElement("div", {
    className: "rev-modal__quote"
  }, openReview.qt), React.createElement("p", {
    className: "rev-modal__text"
  }, openReview.body)))), React.createElement("div", {
    className: 'reviews-list ' + (transitioning ? 'is-transitioning' : '')
  }, visibleReviews.map((r, i) => React.createElement("div", {
    className: "review",
    key: page + '-' + i,
    style: {
      cursor: r.img ? 'pointer' : 'default'
    },
    onClick: () => {
      if (r.img) setOpenReview({
        src: r.img,
        nm: r.nm,
        ci: r.loc,
        when: r.when,
        qt: r.title,
        body: r.body
      });
    }
  }, React.createElement("div", {
    className: "head"
  }, React.createElement("div", {
    className: "av",
    style: {
      backgroundImage: `url(${r.av})`
    }
  }), React.createElement("div", {
    style: {
      flex: 1
    }
  }, React.createElement("div", {
    className: "who"
  }, r.nm, " ", React.createElement("span", {
    className: "verif"
  }, React.createElement(Icon.Verified, null), " Verificada")), React.createElement("div", {
    className: "meta"
  }, r.loc, " \xB7 ", r.when)), React.createElement(Stars, {
    n: r.stars || 5
  })), React.createElement("div", {
    className: "title"
  }, r.title), React.createElement("div", {
    className: "body"
  }, r.body), r.img && React.createElement("img", {
    className: "review-photo",
    src: r.img,
    alt: r.nm,
    loading: "lazy"
  })))), React.createElement("div", {
    className: "review-pager-v2",
    ref: pagerRef
  }, React.createElement("button", {
    className: "rp-nav",
    onClick: e => {
      e.preventDefault();
      changePage(Math.max(0, page - 1));
    },
    disabled: page === 0,
    type: "button",
    "aria-label": "Anterior"
  }, React.createElement(Icon.Arrow, {
    style: {
      transform: 'rotate(180deg)'
    }
  })), React.createElement("div", {
    className: "rp-more"
  }, "M\xE1s rese\xF1as"), React.createElement("button", {
    className: "rp-nav",
    onClick: e => {
      e.preventDefault();
      changePage(Math.min(totalPages - 1, page + 1));
    },
    disabled: page === totalPages - 1,
    type: "button",
    "aria-label": "Siguiente"
  }, React.createElement(Icon.Arrow, null))));
};
const FAQv2 = () => {
  const defaultItems = [{
    q: '¿Es seguro para mi hijo?',
    a: '<p style="margin:0 0 10px 0"><strong>Sí, es 100% natural.</strong> Hecho con creatina dosificadas específicamente para niños.</p><p style="margin:0">No contiene alcohol, ni químicos sintéticos, ni sabor fuerte.</p>'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: '<p style="margin:0 0 10px 0">La mayoría nota más energía y mejor recuperación <strong>entre la 1ª y 2ª semana.</strong></p><p style="margin:0">El ciclo completo de limpieza es de <strong>30 días.</strong></p>'
  }, {
    q: '¿Qué pasa si no veo resultados?',
    a: '<p style="margin:0 0 10px 0">Queremos que de verdad funcione, por eso pedimos que <strong>completes el ciclo de 30 días</strong> (un frasco) dándolo como se indica.</p><p style="margin:0">Si lo hiciste así y no notas ningún cambio, escríbenos por WhatsApp con tu caso y el envase del producto, y buscamos una solución contigo.</p>'
  }, {
    q: '¿Y si mi hijo lo rechaza por el sabor?',
    a: '<p style="margin:0 0 10px 0"><strong>No tiene sabor fuerte.</strong> Se mezcla en el jugo, el agua o la leche de tu hijo y casi no lo nota.</p><p style="margin:0">Basta con <strong>3 gomitas en las mañanas.</strong> La mayoría de niños lo toma sin problema.</p>'
  }, {
    q: '¿Se puede dar junto con vitaminas u otros medicamentos?',
    a: '<p style="margin:0 0 10px 0"><strong>Sí, es compatible</strong> con vitaminas y suplementos del día a día.</p><p style="margin:0">Si tu hijo toma algún medicamento recetado, consulta primero con tu pediatra.</p>'
  }];
  const faqCfg = window.__PP_FAQ || {};
  const fromSettings = [];
  for (var i = 1; i <= 10; i++) {
    var q = faqCfg['q' + i];
    var a = faqCfg['a' + i];
    if (q && a) fromSettings.push({
      q,
      a
    });
  }
  const items = fromSettings.length ? fromSettings : defaultItems;
  const [open, setOpen] = useStateH(-1);
  return React.createElement("section", {
    className: "section bg-white",
    "data-screen-label": "FAQ"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "ink"
  }, "Preguntas frecuentes"), React.createElement("h2", {
    className: "h-section"
  }, "Resolvemos tus dudas"), React.createElement("p", {
    className: "kicker"
  }, "Al hacer tu pedido te contactamos para resolver cualquier duda antes de enviarlo."), React.createElement("div", {
    className: "faq-v2"
  }, items.map((it, i) => React.createElement("button", {
    className: 'row ' + (open === i ? 'open' : ''),
    key: i,
    onClick: () => setOpen(open === i ? -1 : i),
    type: "button"
  }, React.createElement("div", {
    className: "wrap"
  }, React.createElement("div", {
    className: "q"
  }, it.q), React.createElement("div", {
    className: "a",
    dangerouslySetInnerHTML: {
      __html: it.a
    }
  })), React.createElement(Icon.Plus, {
    className: "ic"
  })))));
};
window.SecH = {
  HeroV2,
  LifestyleCarousel,
  EmotionalCTA,
  ReviewsV2,
  FAQv2,
  UsageV2: null,
  NaturalVsChemV2: null
};
const UsageV2 = () => {
  const u = window.__PP_USAGE || {};
  return React.createElement("section", {
    className: "section bg-mint",
    "data-screen-label": "C\xF3mo usarlo"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "mint"
  }, u.eyebrow || 'Súper fácil'), React.createElement("h2", {
    className: "h-section"
  }, function () {
    var t = u.title || '3 gomitas al día. Y listo.';
    var lastDot = t.lastIndexOf('. ');
    if (lastDot === -1) return t;
    var main = t.slice(0, lastDot + 2);
    var pink = t.slice(lastDot + 2);
    return React.createElement("span", null, main, React.createElement("span", {
      style: {
        color: 'var(--pink)'
      }
    }, pink));
  }()), React.createElement("div", {
    className: "usage-v2"
  }, React.createElement("div", {
    className: "scene"
  }, React.createElement("img", {
    src: window.__resources.momkidYuli,
    alt: "Mam\xE1 dando Beast Bites a su hijo"
  }), React.createElement("span", {
    className: "float-chip"
  }, React.createElement("span", {
    className: "dot"
  }), " 3 gomitas \xB7 cuando quieras")), React.createElement("ol", {
    className: "usage-steps"
  }, React.createElement("li", {
    className: "ust"
  }, React.createElement("span", {
    className: "num"
  }, "1"), React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "t"
  }, u.step_1 || 'Agita el frasco'), React.createElement("div", {
    className: "d"
  }, u.step_1_desc || '5 segundos antes de cada uso.'))), React.createElement("li", {
    className: "ust"
  }, React.createElement("span", {
    className: "num"
  }, "2"), React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "t"
  }, u.step_2 || 'Revuelve en su bebida favorita'), React.createElement("div", {
    className: "d"
  }, u.step_2_desc || 'Jugo, agua o leche. Sabor neutro, ni lo nota.'))), React.createElement("li", {
    className: "ust"
  }, React.createElement("span", {
    className: "num"
  }, "3"), React.createElement("div", {
    className: "info"
  }, React.createElement("div", {
    className: "t"
  }, u.step_3 || 'Uso diario por 30 días'), React.createElement("div", {
    className: "d"
  }, u.step_3_desc || '3 gomitas cada mañana, sin interrumpir el ciclo.'))))));
};
const NaturalVsChemV2 = () => {
  var c = window.__PP_COMPARISON || {};
  return React.createElement("section", {
    className: "section bg-mint",
    "data-screen-label": "Gomita vs polvo"
  }, React.createElement(Sec1.Eyebrow, {
    tone: "ink"
  }, c.eyebrow || 'Gomita vs polvo'), React.createElement("h2", {
    className: "h-section"
  }, c.title || 'Misma creatina. La diferencia es que esta sí te la tomas.'), React.createElement("div", {
    className: "nvsq-v2"
  }, React.createElement("div", {
    className: "card-chem"
  }, React.createElement("span", {
    className: "ribbon",
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      fontSize: 10.5,
      fontWeight: 800,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      padding: '5px 12px',
      borderRadius: 'var(--r-full)'
    }
  }, React.createElement(Icon.X, {
    style: {
      width: 11,
      height: 11
    }
  }), " Creatina en polvo"), React.createElement("h3", null, c.chem_title || 'Creatina en polvo'), React.createElement("div", {
    className: "pts"
  }, React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "Toca cargar shaker a todos lados")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "Grumos que no se disuelven bien")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "Se te olvida \xB7 la dejas a la semana")), React.createElement("div", {
    className: "pt"
  }, React.createElement(Icon.X, {
    className: "ic"
  }), React.createElement("span", null, "Sabor a arena \xB7 da pereza tomarlo"))), React.createElement("div", {
    className: "price"
  }, React.createElement("span", {
    style: {
      fontSize: 11.5,
      color: '#8e91a8',
      fontWeight: 600
    }
  }, "F\xE1cil de dejarla"), React.createElement("span", {
    className: "val"
  }, c.chem_price || 'A medio usar'))), React.createElement("div", {
    className: "nv-arrow"
  }, React.createElement(Icon.Arrow, {
    style: {
      transform: 'rotate(90deg)'
    }
  }), React.createElement("span", {
    className: "a-line"
  }, "Hay un mejor camino")), React.createElement("div", {
    className: "card-natural"
  }, React.createElement("div", {
    className: "top-row"
  }, React.createElement("span", {
    className: "ribbon"
  }, React.createElement(Icon.Leaf, null), " Lo que recomendamos")), React.createElement("h3", null, c.nat_title || 'Beast Bites en gomitas'), React.createElement("div", {
    className: "pts"
  }, React.createElement("div", {
    className: "pt"
  }, React.createElement("span", {
    className: "ic"
  }, React.createElement(Icon.Check, null)), React.createElement("span", null, "Creatina monohidratada real", React.createElement("strong", null, ""), "")), React.createElement("div", {
    className: "pt"
  }, React.createElement("span", {
    className: "ic"
  }, React.createElement(Icon.Check, null)), React.createElement("span", null, "90 gomitas \xB7 30 d\xEDas de uso")), React.createElement("div", {
    className: "pt"
  }, React.createElement("span", {
    className: "ic"
  }, React.createElement(Icon.Check, null)), React.createElement("span", null, "Más fuerza y m\xE1s repeticiones")), React.createElement("div", {
    className: "pt"
  }, React.createElement("span", {
    className: "ic"
  }, React.createElement(Icon.Check, null)), React.createElement("span", null, "Sabor rico \xB7 sin shaker ni grumos")), React.createElement("div", {
    className: "pt"
  }, React.createElement("span", {
    className: "ic"
  }, React.createElement(Icon.Check, null)), React.createElement("span", null, "Constancia sin esfuerzo"))), React.createElement("div", {
    className: "price"
  }, React.createElement("span", {
    className: "lab"
  }, c.nat_price_lab || 'Plan de 30 días'), React.createElement("span", {
    className: "was"
  }, c.nat_price_was || '$140.000'), React.createElement("span", {
    className: "val"
  }, c.nat_price_now || '$99.900')))));
};
window.SecH.UsageV2 = UsageV2;
window.SecH.NaturalVsChemV2 = NaturalVsChemV2;
// mover la reseña destacada (copia PC) DENTRO de la galería para que sea parte del bloque sticky
// (se mueve junto con la imagen al scrollear, nunca se cruzan)
(function pinReviewToGallery(){
  function doMove(){
    if(window.innerWidth < 900) return;
    var rev = document.querySelector('.claude-design-root .lp .mini-review-desktop');
    var gal = document.querySelector('.claude-design-root .lp .hero-v2 .pdp-gallery');
    if(!rev || !gal) return;
    if(rev.parentElement !== gal){
      gal.appendChild(rev); // meter la reseña como último hijo de la galería (después de thumbs)
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ setTimeout(doMove, 300); }); }
  else { setTimeout(doMove, 300); }
  var tries = 0; var iv = setInterval(function(){ doMove(); if(++tries > 20) clearInterval(iv); }, 250);
})();
// BENEFICIOS 2 columnas (solo PC): benefits-grid IZQ + before/after (.ba-card) DER
(function benefits2col(){
  function doWrap(){
    if(window.innerWidth < 900) return;
    var grid = document.querySelector('.claude-design-root .lp .benefits-grid');
    var baCard = document.querySelector('.claude-design-root .lp .section.bg-white .ba-card');
    if(!grid || grid.parentElement.classList.contains('benefits-2col')) return;
    var wrap = document.createElement('div');
    wrap.className = 'benefits-2col';
    grid.parentElement.insertBefore(wrap, grid);
    wrap.appendChild(grid);                    // beneficios a la izquierda (col 1)
    if(baCard){ wrap.appendChild(baCard); baCard.classList.add('ba-card--in2col'); }  // before/after a la derecha (col 2)
    else { var slot=document.createElement('div'); slot.className='benefits-img-slot'; slot.textContent='Imagen del producto'; wrap.appendChild(slot); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){setTimeout(doWrap,300);});
  else setTimeout(doWrap,300);
  var t=0,iv=setInterval(function(){doWrap();if(++t>20)clearInterval(iv);},250);
})();

// ZOOM CLICK-TO-ZOOM estilo GYMSHARK (solo PC): indicador circular con "+"/"−" que sigue el
// cursor; 1er click hace zoom FIJO en esa zona; 2º click (misma zona) aleja; click en OTRA zona
// re-ancla. ⚠️ CLAVE anti-"curva": el paneo se hace con TRANSLATE (no moviendo transform-origin,
// que causaba un arco). transform-origin queda FIJO en center y solo cambian scale+translate →
// el desplazamiento entre zonas es en LÍNEA RECTA. Event delegation en document (sobrevive React).
(function heroClickZoom(){
  if(typeof window==='undefined') return;
  var S = 3.2;                                                 // factor de zoom (coincide con CSS visual)
  function pct(stage, e){
    var r = stage.getBoundingClientRect();
    var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
    var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
    return { x:x, y:y };
  }
  // translate (en % del propio elemento) para centrar el punto (x,y), clamp a los bordes
  // para que el zoom nunca muestre vacío. limite: (50 - 50/S).
  function panFor(x, y){
    // MAPEO LINEAL (estándar Panzoom/D3): mapea el click [0..100] al rango de pan [+lim..-lim].
    // cada zona clickeada es ÚNICA (sin franja muerta en bordes), llega a las orillas sin mostrar
    // vacío, y el cliente puede enfocar EXACTAMENTE la zona que le interesa.
    // CENTRA EXACTO el punto clickeado: tx=(50-x)*S (el *S es la clave; sin él nunca centraba).
    // clamp a (S-1)/2*100 = máximo pan sin mostrar fondo vacío. El cliente enfoca lo que quiere.
    var lim = (S - 1) / 2 * 100;
    var tx = Math.max(-lim, Math.min(lim, (50 - x) * S));
    var ty = Math.max(-lim, Math.min(lim, (50 - y) * S));
    return { tx:tx, ty:ty };
  }
  function zoomIn(stage, img, p){
    var pan = panFor(p.x, p.y);
    // scale alrededor de center (transform-origin fijo) + translate% relativo al elemento => recto
    img.style.transform = 'translate('+pan.tx.toFixed(2)+'%, '+pan.ty.toFixed(2)+'%) scale('+S+')';
    stage.classList.add('is-zoomed');
    stage.dataset.zx = p.x.toFixed(2);
    stage.dataset.zy = p.y.toFixed(2);
    setLens(stage, true);
  }
  function zoomOut(stage, img){
    stage.classList.remove('is-zoomed');
    img.style.transform = 'translate(0%, 0%) scale(1)';
    delete stage.dataset.zx; delete stage.dataset.zy;
    setLens(stage, false);
  }
  // icono: "+" cuando NO esta en zoom (acercar), "-" cuando SI (alejar)
  var PLUS  = '<line x1="12" y1="7.5" x2="12" y2="16.5"/><line x1="7.5" y1="12" x2="16.5" y2="12"/>';
  var MINUS = '<line x1="7.5" y1="12" x2="16.5" y2="12"/>';
  function ensureLens(stage){
    var lens = stage.querySelector('.pdp-lens');
    if(!lens){
      lens = document.createElement('div');
      lens.className = 'pdp-lens';
      stage.appendChild(lens);
    }
    return lens;
  }
  function setLens(stage, zoomed){
    var lens = ensureLens(stage);
    lens.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round">'+(zoomed?MINUS:PLUS)+'</svg>';
  }
  // CLICK: toggle / re-anclaje
  document.addEventListener('click', function(e){
    if(window.innerWidth < 900) return;                       // solo PC
    var stage = e.target.closest ? e.target.closest('.pdp-stage') : null;
    if(!stage || !stage.closest('.hero-v2')) return;
    var img = stage.querySelector('.pdp-img');
    if(!img) return;
    var p = pct(stage, e);
    if(!stage.classList.contains('is-zoomed')){
      zoomIn(stage, img, p);                                  // no estaba en zoom => acercar aqui
    } else {
      var dx = Math.abs(p.x - parseFloat(stage.dataset.zx||50));
      var dy = Math.abs(p.y - parseFloat(stage.dataset.zy||50));
      if(dx > 12 || dy > 12) zoomIn(stage, img, p);           // click en OTRA zona => re-anclar (recto)
      else zoomOut(stage, img);                               // click en la misma zona => alejar
    }
  });
  // el indicador circular sigue el cursor 1:1 (throttle con rAF = sedoso, sin lag); muestra + o -
  var lensRaf = null, lensPending = null;
  function moveLens(){
    lensRaf = null;
    if(!lensPending) return;
    var stage = lensPending.stage, cx = lensPending.cx, cy = lensPending.cy;
    var lens = ensureLens(stage);
    if(!lens.firstChild) setLens(stage, stage.classList.contains('is-zoomed'));
    var r = stage.getBoundingClientRect();
    lens.style.left = (cx - r.left) + 'px';
    lens.style.top  = (cy - r.top) + 'px';
  }
  document.addEventListener('mousemove', function(e){
    if(window.innerWidth < 900) return;
    var stage = e.target.closest ? e.target.closest('.pdp-stage') : null;
    if(!stage || !stage.closest('.hero-v2')) return;
    lensPending = { stage:stage, cx:e.clientX, cy:e.clientY };
    if(!lensRaf) lensRaf = requestAnimationFrame(moveLens);
  }, { passive:true });
})();

if(typeof triggerRSI!=='undefined')window.triggerRSI=triggerRSI;
})();
